<template>
<div>
  <div v-if="!atendimento" class="d-flex justify-content-center align-items-center flex-column mt-3">
    <az-loading msg="Carregando dados do paciente..." v-if="$store.state.loading" />
    <button type="button" class="btn btn-outline-primary" @click="$router.go(-1)" v-else>Voltar</button>
  </div>

  <div v-if="atendimento" class="w3-animate-opacity" 
    :style="( ver_historico ? 'margin-left: 300px; ' : '' ) + ( resultado_fixo_direita ? 'margin-right: 300px; ' :  '' )">

    <div id="basevideo"></div>

    <ficha-paciente 
      :id_atendimento="atendimento.id_atendimento"
      :id_unidade_operacao="atendimento.marcacao ? atendimento.marcacao.id_unidade_operacao : null"
      :paciente="atendimento.paciente" 
      :plano="atendimento.plano"
      id="ficha-paciente" 
      :super_resumo="true"
      @atualizado="load()" />

    <div class="row mb-0" v-if="!atendimento || !atendimento.avulso || !atendimento.avulso.fl_no_pep">
      <div class="col col-12 col-md-4">
        <!-- d-flex flex-md-row flex-column -->
        <a id="lista-de-pacientes" href="#" @click.prevent="ir_para_pacientes()" class="btn btn-outline-primary btn-sm mb-2 mr-2">
          Pacientes
        </a>
        <router-link
          v-if="false"
          id="lista-de-pacientes"
          class="btn btn-outline-primary btn-sm mb-2 mr-2"
          :to="{ path: ( $route.meta.vacina ) 
            ? '/vacina' 
            : ( 
                ( $route.meta.enfermagem || fila ) 
                  ? '/assistencia/atend' 
                  : ( $route.meta.internacao ? '/internacao/internados' : '/consultorio' ) 
            ) }">
          Pacientes
        </router-link>
        <a id="historico-prontuario" href="#" class="btn btn-outline-primary btn-sm mb-2 mr-2" @click.prevent="abrir_historico ()">
          <i class="fa fa-search-plus mr-2" aria-hidden="true" v-if="!ver_historico"></i>
          <i class="fa fa-search-minus mr-2" aria-hidden="true" v-else></i>
          Histórico
        </a>
        <a href="#" class="btn btn-outline-primary btn-sm mb-2 mr-2" @click.prevent="abrir_historico (true)"
          title="Histórico Resumido">
          <i class="fas fa-notes-medical"></i>
        </a>

        <button class="btn btn-outline-primary btn-sm mb-2 mr-2" type="button" id="button-addon2" @click="abrir_perfil()" title="Histórico">
            <i class="fas fa-id-badge"></i>
        </button>

        <a href="#" class="btn btn-outline-primary btn-sm mr-2 mb-2" @click.prevent="recorrencia ()"
          v-if="atendimento.marcacao && atendimento.marcacao.recorrencias && atendimento.marcacao.recorrencias.length">
          <i class="fas fa-sync-alt"></i>
        </a>

        <button class="btn btn-sm mb-2" :class="'btn-outline-' + atendimento.marcacao.sinalizador_atendimento.st_cor" v-if="atendimento.marcacao && atendimento.marcacao.sinalizador_atendimento" :title="atendimento.marcacao.sinalizador_atendimento.st_sinalizador_atendimento" @click="lembrete()">
            <i :class="atendimento.marcacao.sinalizador_atendimento.st_icon"></i>
        </button>
      </div>
      <div class="col col-12 col-md-8 text-right">
        <!-- justify-content-end d-flex flex-md-row flex-column -->
        <a href="#" class="card-link" @click.prevent="tour()">
          <i class="h5 mb-0 far fa-compass mr-2"></i>
        </a>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm ml-0 ml-md-2 mb-2"
          :disabled="true"
        >{{ getFormatDate(atendimento.dt_inicio,'DD/MM/YYYY') }}</button>
        <template v-if="pode_alterar || 1==1">
          <!-- re-chamada do paciente -->
          <button 
            data-toggle="tooltip" 
            data-placement="top" 
            title="Chamar Novamente"
            v-if="atendimento.marcacao || atendimento.origem"
            id="pep-chamar-novamente"
            type="button"
            class="btn btn-outline-danger btn-sm ml-2 mb-2"
            @click="chamarNovamente(atendimento.marcacao ? atendimento.marcacao : atendimento.origem)">
            <i class="fa fa-volume-up" aria-hidden="true" v-if="!$store.state.loading"></i>
            <div class="spinner-border spinner-border-sm" role="status" v-else>
              <span class="sr-only">Loading...</span>
            </div>
          </button>
          <!-- Video Chamada -->
          <button
            id="botao-video-chamada"
            type="button"
            class="btn btn-outline-success btn-sm ml-2 mb-2"
            data-toggle="tooltip" data-placement="top" title="Vídeo chamada"
            v-if="!atendimento.fl_avulso && !atendimento.marcacao.item_status.finalizado"
            @click="toggleVideo ()">
            <i class="fas fa-video" v-if="!video"></i>
            <i class="fas fa-video-slash" v-else></i>
          </button>

          <!-- Doctor Assistent -->
          <button
            id="botao-doctor-assistent"
            type="button"
            class="btn btn-outline-success btn-sm ml-2 mb-2"
            data-toggle="tooltip" data-placement="top" title="Doctor Assistent"
            v-if="!atendimento.fl_avulso && daai_ativo" 
            @click="toggleDoctorAssistent ()">
            IA
          </button>

          <!-- Gravação de Vídeo -->
          <a
            id="botao-video-chamada"
            type="button"
            class="btn btn-outline-success btn-sm ml-2 mb-2"
            :href="'https://gravacao.klingo.app/?paciente=' + encodeURIComponent(atendimento.paciente.st_nome)"
            data-toggle="tooltip" data-placement="top" title="Gravação de Vídeo"
            target="_blank" v-if="tem_gravacao_video">
            <i class="fas fa-film"></i>
          </a>

          <!-- Reconhecimento de Voz -->
          <button
            id="botao-reconhecimento-voz"
            type="button"
            class="btn btn-outline-success btn-sm ml-2 mb-2"
            data-toggle="tooltip" data-placement="top" title="Reconhecimento de Voz."
            @click="reconhecer_voz()"
          >
            <i class="fas fa-comment-alt"></i>
          </button>

          <!-- Galeria de Imagens -->
          <button
            id="botao-galeria-de-imagens"
            type="button"
            class="btn btn-outline-success btn-sm ml-2 mb-2"
            data-toggle="tooltip" data-placement="top" title="Galeria de Imagens."
            @click="abrir_galeria_imagens()"
          >
            <i class="fas fa-images"></i>
          </button>

          <!-- Resultados -->
          <button id="botao-resultados-exames" type="button"
            class="btn btn-outline-success btn-sm ml-2 mb-2"
            data-toggle="tooltip" data-placement="top" title="Resultados de Exames."
            @click="resultados ()">
            <i class="fas fa-table"></i>
          </button>

          <!-- Lembretes -->
          <button type="button" class="btn btn-outline-secondary btn-sm ml-2 mb-2 text-nowrap"
            data-toggle="tooltip" data-placement="top" title="Lembrete relacionado ao procedimento."
            @click="lembrete ()">
            <i class="fas fa-thumbtack mr-2"></i>
            <i class="fa fa-play"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm ml-2 mb-2 text-nowrap"
            data-toggle="tooltip" data-placement="top" title="Lembrete relacionado ao paciente."
            @click="lembrete_pac()">
            <i class="fas fa-thumbtack mr-2"></i>
            <i class="fas fa-user-injured"></i>
          </button>

          <!-- Alergia -->
          <button type="button" class="btn btn-outline-danger btn-sm ml-2 mb-2"
            data-toggle="tooltip" data-placement="top" title="Alergias"
            @click="abrir_alergias()">
            <i class="fa-solid fa-droplet-slash"></i>
          </button>

          <!-- Orçamento -->
          <template v-if="pode_gerar_orcamento">
            <button type="button" class="btn btn-outline-danger btn-sm ml-2 mb-2" data-toggle="tooltip" data-placement="top" title="Orçamento" @click="abrir_orcamento()">
              <i class="fas fa-dollar-sign"></i>
            </button>

            <button type="button" class="btn btn-outline-danger btn-sm ml-2 mb-2" data-toggle="tooltip" data-placement="top" title="Ver conta" @click="$refs.conta.abrir()" v-if="atendimento.marcacao && atendimento.marcacao.id_marcacao">
              <i class="fa-solid fa-file-invoice-dollar"></i>
            </button>
          </template>
          
          <!-- Programar Retorno -->
          <span class="ml-2">
            <retorno-atendimento 
              :id_atendimento="atendimento.id_atendimento" 
              :id_procedimento="atendimento.marcacao ? atendimento.marcacao.id_procedimento : null"
              @refresh="load()" />
          </span>

        </template>
      </div>
    </div>

    <transition name="fade">
      <div>
        <input type="hidden" id="video-aberto" v-if="video">
        <az-video-call 
          :block_gravar="block_gravar_telemed"
          v-show="video" 
          :sala="sala_video" 
          :master="true"
          :telefone="( atendimento.paciente.cadastro && atendimento.paciente.cadastro.telefones ) ? atendimento.paciente.cadastro.telefones.celular : ''"
          :atendimento="atendimento" />
      </div>
    </transition>

    <transition name="fade">
        <div v-if="doctorAssistentInit">
            <input type="hidden" id="doctorassistent-aberto" >
            <doctor-assistant ref="daai" :atendimento="atendimento" />
        </div>
    </transition>

    <!-- Consulta de Histórico de Prontuário -->
    <template v-if="conteudo">
      <pep-view-card :side="true" :marcacao="conteudo" tamanho="P" :pode_atender="false" v-if="!legado && conteudo" 
        :historico="true"  @abrir_doc_view="abrir_doc_view" @retornarAoAtendimento="retornarAoAtendimento" />

      <pep-view-card-legado :side="true" :item="conteudo" v-else />
    </template>

    <div v-show="!conteudo">

        <!-- Retorno de Atendimento -->
        <template v-if="atendimento && atendimento.retorno_atendimentos && atendimento.retorno_atendimentos.length">
            <div class="alert alert-primary mb-2 d-flex justify-content-between" v-for="(ret, irx) in atendimento.retorno_atendimentos" :key="irx">
                <div>
                    <i class="fas fa-undo-alt mr-2"></i>
                    Retorno Programado para: <strong>{{ $util.getFormatDate(ret.dt_retorno) }}</strong> 
                    <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                    <small>{{ ret.procedimento.search }}</small>
                    <div class="small text-muted">{{ getHumanDuration(ret.dt_retorno) }}</div>
                    <div class="small" v-if="ret.st_observacoes">{{ ret.st_observacoes }}</div>
                </div>
                <div>
                    <button type="button" class="btn btn-outline-danger" @click.prevent="removerRetorno(ret)">
                        <i class="fas fa-trash-alt"></i>
                    </button>
                </div>
            </div>
        </template>

        <!-- Pré Atendimento -->  
        <pre-atendimento-view :marcacao="atendimento.marcacao" v-if="atendimento" :callback_preenchimento="preencher_formularios" />

        <!-- Arquivos da Marcação -->
        <div v-if="atendimento && atendimento.marcacao && atendimento.marcacao.arquivos.length">
            <p class="alert alert-primary">
            <span class="text-muted mr-2">Anexos do Atendimento:</span>
            <a :href="arq.arquivo.temporary_url" class="text-white"
                v-for="(arq, iax) in atendimento.marcacao.arquivos" :key="iax" target="_blank">
                <span class="badge badge-primary p-2 mr-2">
                <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                {{ arq.arquivo.st_titulo }}  
                </span>
            </a>
            </p>
        </div>

        <lembrete-paciente ref="lembretepac" v-model="atendimento.paciente" />

        <p class="alert alert-warning py-1 mb-1 lead" v-if="atendimento.lembrete">
            <i class="fas fa-thumbtack mr-2" data-toggle="tooltip" data-placement="top" title="Lembrete do Atendimento"></i>
            {{ atendimento.lembrete.st_lembrete }}
        </p>

        <div v-if="instrucoes && instrucoes.length">
            <p class="alert alert-warning small py-1 mb-1" v-for="(instr, iix) in instrucoes" :key="iix">
                <i class="far fa-credit-card mr-2" aria-hidden="true"></i>
                {{ instr.st_titulo }}
                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                {{ instr.st_descricao }}
            </p>
        </div>

        <div class="form-row" v-if="atendimento.medico_solicitante || atendimento.local_momento || atendimento.internacao">
            <div class="col col-12" :class="( atendimento.local_momento || atendimento.internacao ) ? 'col-md-6' : ''" v-if="atendimento.medico_solicitante">
                <div class="alert alert-info small py-1 px-2 mb-1">
                    Solicitante: {{ atendimento.medico_solicitante.search }}
                </div>
            </div>

            <div class="col col-12" :class="atendimento.medico_solicitante ? 'col-md-6' : ''" v-if="atendimento.local_momento || atendimento.internacao">
                <template v-if="atendimento.internacao">
                    <div class="alert alert-info small py-1 px-2 mb-1 d-flex justify-content-between">
                        <div>
                            <template v-if="atendimento.internacao.local_momento">
                                <i class="fa-solid fa-street-view fa-fw mr-1"></i>
                                <strong>{{ atendimento.internacao.local_momento.search }}</strong>
                            </template>
                        </div>
                        <div>
                            <i class="fa-solid fa-bed fa-fw mr-1"></i>
                            #{{ atendimento.id_internacao }} 
                            <template v-if="atendimento.internacao.local">
                                | {{ atendimento.internacao.local.st_sigla ? atendimento.internacao.local.st_sigla : atendimento.internacao.local.st_local }}
                            </template>
                        </div>
                    </div>
                </template>

                <template v-if="atendimento.local_momento && !atendimento.internacao">
                    <div class="alert alert-info small py-1 px-2 mb-1">
                        <i class="fa-solid fa-street-view fa-fw mr-2"></i>
                        <strong>{{ atendimento.local_momento.st_local }}</strong>
                    </div>
                </template>
            </div>
        </div>

      <div class="mb-1" v-if="pep_info_cid || cid_obrig || ( atendimento.marcacao && atendimento.marcacao.recepcao && atendimento.marcacao.recepcao.fl_emergencia )">
        <az-input 
            v-if="!atendimento.cid"
            sizing="sm"
            :compact="true"
            :label="'CID'"
            :edicao="false"
            v-model="atendimento.cid">
            <template v-slot:buttonposb>
                <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="editar_cid()">
                    <i class="fas fa-pen"></i>
                </button>
                <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Listar CIDs utilizados" @click="listar_cids()">
                    <i class="fas fa-list"></i>
                </button>
                </div>
            </template>
        </az-input>

        <az-input 
            v-else
            sizing="sm"
            :compact="true"
            :label="'CID ' + atendimento.cid.st_codigo"
            :edicao="false"
            v-model="atendimento.cid.st_cid">
            <template v-slot:buttonposb>
                <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" id="button-addon2" data-toggle="tooltip" title="Editar CID" @click="editar_cid()">
                    <i class="fas fa-pen"></i>
                </button>
                <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" title="Listar CIDs utilizados" @click="listar_cids()">
                    <i class="fas fa-list"></i>
                </button>
                <button class="btn btn-outline-success" type="button" id="button-addon2" data-toggle="tooltip" title="Vincular o CID ao paciente" @click="vincular_ao_paciente()" :disabled="$store.state.loading">
                    <i class="fa-regular fa-image-user"></i>
                </button>
                </div>
            </template>
        </az-input>
      </div>

      <!-- ENFERMAGEM -->
      <template v-if="$route.meta.enfermagem || $route.meta.vacina">
        <atendimento-enfermagem-item 
            ref="aei" 
            :atendimento="atendimento" 
            :modelos="enf_modelos" 
            :fila="filaLaudo" 
            :id_fila_proc="id_fila_proc"
            @refresh="load()">
          <!-- Atendimento Pausado -->
          <template v-if="atendimento.marcacao && atendimento.marcacao.item_status.valor == 'pausado'">
            <button type="button" class="btn btn-outline-success btn-sm ml-2" @click="retomarAtendimento()"
              v-if="atendimento.marcacao && ( !atendimento.marcacao.item_status.finalizado || atendimento.marcacao.item_status.valor == 'concluido' )">
              <i class="fa fa-play" aria-hidden="true"></i>
            </button>
          </template>

          <template v-else>

            <!-- Tempo -->
            <button class="btn btn-outline-secondary btn-sm mx-2 text-nowrap" type="button"
              data-toggle="tooltip" data-placement="top" title="Duração do Atendimento">
              <pre class="mb-1"><i class="fas fa-stopwatch mr-2"></i>{{ tempo }}</pre>
            </button>

            <!-- Pausar Atendimento -->
            <template v-if="atendimento_iniciado()">
              <button type="button" class="btn btn-outline-danger btn-sm mr-1" @click="pausarAtendimento()" title="Pausar Atendimento"
                v-if="pode_pausar && atendimento.marcacao && ( !atendimento.marcacao.item_status.finalizado || atendimento.marcacao.item_status.valor == 'concluido' )">
                <i class="fa fa-pause" aria-hidden="true"></i>
              </button>
            </template>

            <!-- Não Compareceu -->
            <button type="button" class="btn btn-secondary btn-sm mr-1" @click="naoComparecer(atendimento)"
                title="Cirurgia Suspensa"
                v-if="atendimento.marcacao && ( !atendimento.marcacao.item_status.finalizado || atendimento.marcacao.item_status.valor == 'concluido' ) && is_cirurgia">
              CS
            </button>

            <!-- Finalizar Atendimento -->
            <button type="button" class="btn btn-danger btn-sm" @click="selecionarFinalizar()"
              v-if="atendimento.marcacao && ( !atendimento.marcacao.item_status.finalizado || atendimento.marcacao.item_status.valor == 'concluido' )">
              <span class="d-block d-lg-none">
                <i class="fas fa-power-off"></i>
              </span>
              <span class="d-none d-lg-block">
                <i class="fas fa-power-off mr-2"></i> 
                Finalizar Atendimento
              </span>
            </button>

            <!-- Cancelar Atendimento -->
            <template v-if="
                atendimento.pode_alterar_prontuario && ( 
                  atendimento.fl_avulso || ( 
                    atendimento.marcacao && ( atendimento.marcacao.item_status.finalizado && atendimento.marcacao.item_status.valor != 'concluido' )
                  )
                )">
              <button type="button" class="btn btn-outline-danger btn-sm ml-3" @click="cancelarProntuario()">
                <i class="fa fa-times mr-2" aria-hidden="true"></i>
                Cancelar Atendimento
              </button>

              <button type="button" class="btn btn-outline-danger btn-sm ml-1" @click="reabrirProntuario()"
                v-if="!atendimento.fl_avulso && ( atendimento.dt_inicio.substr(0,10) == $util.hoje() )">
                <i class="fa fa-play mr-2" aria-hidden="true"></i>
                Reabrir
              </button>
            </template>

          </template>
        </atendimento-enfermagem-item>
      </template>

      <template v-else>
        <div v-if="atendimento && atendimento.marcacao && atendimento.marcacao.infusao" class="alert alert-info d-flex justify-content-between p-2 mb-2"> 
            <div>
                {{ atendimento.marcacao.infusao.st_titulo }} 
                <span class="badge badge-secondary ml-2" v-if="atendimento.marcacao.in_qt_dia">D{{ atendimento.marcacao.in_qt_dia }}</span>
            </div>
            <a href="#" @click.prevent="consultar_contatos('App\\azure\\receita', atendimento.marcacao.infusao.protocolo.receita.id_receita, atendimento.marcacao.infusao.protocolo.receita)" v-if="atendimento.marcacao.infusao && atendimento.marcacao.infusao.protocolo && atendimento.marcacao.infusao.protocolo.receita && atendimento.marcacao.infusao.protocolo.receita.contato">
                <span class="badge" :class="( atendimento.marcacao.infusao.protocolo.receita.contato.id_marcacao == atendimento.marcacao.id_marcacao ) ? 'badge-' + atendimento.marcacao.infusao.protocolo.receita.contato.contato_status.st_color : 'badge-light text-muted'">
                    {{ atendimento.marcacao.infusao.protocolo.receita.contato.contato_status.search }}
                    / {{ quando(atendimento.marcacao.infusao.protocolo.receita.contato.created_at) }}
                </span>

                <span v-if="( atendimento.marcacao.infusao.protocolo.receita.contato.id_marcacao == atendimento.marcacao.id_marcacao )" title="Validação da Prescrição para Marcação" class="ml-2">
                    <i class="fa-regular fa-calendar-check text-success"></i>
                </span>
            </a>
            <a href="#" @click.prevent="consultar_contatos('App\\azure\\receita', atendimento.marcacao.infusao.protocolo.receita.id_receita, atendimento.marcacao.infusao.protocolo.receita)" v-else-if="atendimento.marcacao.infusao && atendimento.marcacao.infusao.protocolo && atendimento.marcacao.infusao.protocolo.receita">
                <span class="badge badge-light text-muted">
                    ?
                </span>
            </a>
            <div v-if="atendimento.marcacao.in_qt_ciclo && atendimento.marcacao.infusao.ciclos">
                <span class="badge badge-secondary mr-3" v-if="atendimento.marcacao.infusao.protocolo && atendimento.marcacao.infusao.protocolo.receita && atendimento.marcacao.infusao.protocolo.receita.editada">
                    Editada ({{ atendimento.marcacao.infusao.protocolo.receita.editada.id_receita }})
                </span>
                
                <i class="fa-solid fa-arrows-spin mr-2"></i>
                {{ atendimento.marcacao.in_qt_ciclo }}/{{ atendimento.marcacao.infusao.ciclos }}

                <template v-if="atendimento.marcacao && atendimento.marcacao.infusao && atendimento.marcacao.infusao.protocolo && atendimento.marcacao.infusao.protocolo.receita">
                    <a href="#" class="card-link ml-3" v-if="$store.state.user.medico" @click.prevent="editar_prescricao_protocolo(atendimento.marcacao)" title="Editar Prescrição do Protocolo">
                        <i class="fa-solid fa-pen-to-square"></i>
                    </a>
                </template>
            </div>
            <div v-else-if="atendimento.marcacao.infusao.protocolo && atendimento.marcacao.infusao.protocolo.receita">
                <span class="badge badge-secondary mr-3" v-if="atendimento.marcacao.infusao.protocolo && atendimento.marcacao.infusao.protocolo.receita && atendimento.marcacao.infusao.protocolo.receita.editada">
                    Editada ({{ atendimento.marcacao.infusao.protocolo.receita.editada.id_receita }})
                </span>

                <template v-if="atendimento.marcacao && atendimento.marcacao.infusao && atendimento.marcacao.infusao.protocolo && atendimento.marcacao.infusao.protocolo.receita">
                    <a href="#" class="card-link ml-3" v-if="$store.state.user.medico" @click.prevent="editar_prescricao_protocolo(atendimento.marcacao)" title="Editar Prescrição do Protocolo">
                        <i class="fa-solid fa-pen-to-square"></i>
                    </a>
                </template>
            </div>
        </div>

        <registrar-contatos ref="contatos" titulo="Validação" @refresh="load()" />
      </template>

      <!-- Registro em edição -->
      <div v-if="!$route.meta.enfermagem && !$route.meta.vacina">
        
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" v-if="registro_pep">
            <a class="nav-link active" style="padding: 0.25rem 1rem" id="registro-tab" data-toggle="tab" href="#registro" role="tab" @click="index = -1">
              <span class="small">
                {{ registro_pep.modelo ? registro_pep.modelo.st_modelo_prontuario : 'Notas' }}
              </span>
            </a>
          </li>
          <template v-for="(item, index) in atendimento.atendimento_procedimentos">
            <li class="nav-item" :key="index" v-show="!index || !item.procedimento.fl_block_aba" v-if="true">
              <a class="nav-link" style="padding: 0.25rem 1rem" :class="( index || registro_pep ) ? '' : 'active'" :id="'t-' + index + 'tab'" data-toggle="tab" :href="'#t-' + index"
                role="tab">
                <span v-if="item.fl_ativo" class="small">{{ item.procedimento.st_procedimento }}</span>
                <s v-else>{{ item.procedimento.st_procedimento }}</s>
                <span class="badge badge-secondary ml-1" v-if="item.st_regiao">{{ item.st_regiao }}</span>
                <span v-if="item.laudo && item.laudo.status_laudo && item.laudo.status_laudo.st_color" class="small">
                    <i class="fa-solid fa-circle ml-1" :class="'text-' + item.laudo.status_laudo.st_color"></i>
                </span>
              </a>
            </li>
          </template>

          <!-- Receitas e Prescrições -->
          <template v-if="lista_receita.length">
            <li class="nav-item">
                <a class="nav-link" style="padding: 0.25rem 1rem" id="receita-tab" data-toggle="tab" href="#receita" role="tab" @click="index = -1" title="Receitas e Prescrições">
                    <i class="fa-solid fa-prescription"></i>
                    <span class="badge badge-primary ml-1" v-if="1==0 && lista_receita.length > 1">{{ lista_receita.length }}</span>
                </a>
            </li>
          </template>

          <!-- Requisições -->
          <template v-if="lista_requisicao.length">
            <li class="nav-item">
                <a class="nav-link" style="padding: 0.25rem 1rem" id="requisicao-tab" data-toggle="tab" href="#requisicao" role="tab" @click="index = -1" title="Requisições">
                    <i class="fas fa-heartbeat"></i>
                    <span class="badge badge-primary ml-1" v-if="1==0 && lista_requisicao.length > 1">{{ lista_requisicao.length }}</span>
                </a>
            </li>
          </template>

          <!-- Documentos -->
          <template v-if="lista_documentos.length">
            <li class="nav-item">
                <a class="nav-link" style="padding: 0.25rem 1rem" id="lista-documentos-tab" data-toggle="tab" href="#lista-documentos" role="tab" @click="index = -1" title="Documentos">
                    <i class="far fa-file-alt"></i>
                    <span class="badge badge-primary ml-1" v-if="1==0 && lista_documentos.length > 1">{{ lista_documentos.length }}</span>
                </a>
            </li>
          </template>

          <!-- Inclusão de Procedimento -->
          <li class="nav-item" v-if="pode_alterar && !atendimento.fl_avulso">
            <a class="nav-link" style="padding: 0.25rem 1rem" id="add-tab" href="#" @click.prevent="addProcedimento ()">
              <i class="fas fa-plus"></i>
            </a>
          </li>
        </ul>

        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade"
            :class="( index || registro_pep ) ? '' : 'show active'"
            :id="'t-' + index"
            role="tabpanel"
            aria-labelledby="home-tab"
            v-for="(item, index) in atendimento.atendimento_procedimentos"
            :key="index">

            <div class="alert alert-secondary py-1 px-2 small mb-0" v-if="item.revisor">
                Responsável: {{ item.medico ? item.medico.st_nome_exibicao : atendimento.medico.st_nome_exibicao }} | 
                Revisado por: {{ item.revisor.st_nome_exibicao }}
            </div>

            <div class="mb-3" v-if="item.anamnese">
          
              <template v-if="eh_laudo(item)">
          
                <div class="card">
                  <div class="card-body">

                    <div v-if="item.laudo.doc_certificado_link" class="d-flex flex-column mb-3">
                      <a :href="item.laudo.doc_certificado_link" class="btn btn-outline-primary" target="_blank">
                        <i class="fa fa-print mr-2" aria-hidden="true"></i>
                        Laudo Assinado
                      </a>
                    </div>

                    <div v-else-if="!pode_alterar" class="d-flex flex-column mb-3">
                      <a href="#" class="btn btn-outline-primary" @click="imprimir(item.laudo)">
                        <i class="fa fa-print mr-2" aria-hidden="true"></i>
                        Imprimir Laudo
                      </a>
                    </div> 

                    <anexar-laudo-externo :laudo_arq="item.laudo" :pode_alterar="pode_alterar" @refresh="load()" />
                      <!-- v-if="!eh_laudo_texto_rico(item) || ( item.laudo.arquivos && item.laudo.arquivos.length ) || ( item.laudo.laudo_entregas && item.laudo.laudo_entregas.length )" -->

                      <!-- <visualizar-laudo-externo :atp="item" />
                    </template> -->

                    <template v-if="!item.laudo.arquivos || !item.laudo.arquivos.filter(arq => arq.st_tipo_especial != 'anexo').length">

                      <laudo-editor 
                        ref="laudoedit"
                        :validate="validate"
                        v-model="item.laudo" 
                        :atendimento="atendimento"
                        :atendimento_procedimento="item" 
                        :pode_alterar="pode_alterar && !item.laudo.doc_certificado_link && ( !item.laudo.status_laudo || ( !item.laudo.status_laudo.fl_pronto && !item.laudo.status_laudo.fl_revisao ) )" 
                        :assinatura="!item.laudo.doc_certificado_link" @assinar="assinar" />

                      <div class="text-right" v-if="item.laudo.doc_certificado_link && pode_alterar">
                        <button class="btn btn-sm btn-link text-danger" type="button" @click="cancelar_assinatura_laudo(item.laudo)">
                          <i class="fa fa-times mr-1" aria-hidden="true"></i>
                          Cancelar Assinatura
                        </button>
                      </div>

                    </template>

                    <div class="text-right" v-if="item.laudo.status_laudo">
                      <az-submit class="mt-3" color="link text-danger btn-sm" @click="status_laudo(item.laudo, false)" v-if="item.laudo.status_laudo.fl_pronto">
                        <i class="fa fa-times mr-1" aria-hidden="true"></i>
                        Cancelar Laudo Pronto
                      </az-submit>

                      <az-submit class="mt-3" color="success btn-sm" @click="status_laudo(item.laudo, true)" v-if="!item.laudo.status_laudo.fl_pronto">
                        Fechar Laudo Pronto para Entrega
                      </az-submit>
                    </div>

                    <!--
                    <div class="text-right" v-else-if="item.laudo.status_laudo">
                      <span>
                        {{ item.laudo.status_laudo.search }}
                      </span>
                    </div>
                    -->

                    <div class="alert alert-primary d-flex justify-content-between mt-3 mb-0" v-if="item.laudo.arquivos && item.laudo.arquivos.length">
                      <div>
                        {{ item.laudo.arquivos.length }} arquivo(s)
                      </div>

                      <div>
                        <a href="#" @click.prevent="toggle_ver_anexos_laudo(item)">
                          <i class="fa-solid fa-eye-slash fa-fw" v-if="!item.laudo.ver_anexos"></i>
                          <i class="fa-solid fa-eye fa-fw" v-else></i>
                        </a>
                      </div>
                    </div>

                    <ver-arquivos-rolagem class="mt-3" v-if="item.laudo.ver_anexos" :arquivos="item.laudo.arquivos" />

                  </div>
                </div>
              </template>

              <template>
                <anamnese
                  :block_doc_titulo="block_doc_titulo"
                  ref="anamnese"
                  :validate="validate"
                  v-model="item.anamnese"
                  :ehlaudo="eh_laudo(item)"
                  :marcacao="atendimento.marcacao"
                  :atendimento_procedimento="item"
                  :id_paciente="atendimento.id_paciente"
                  :tipo_consulta="( atendimento.marcacao && item.procedimento.id_classe_procedimento == 1 ) ? ( item.ch_tipo_consulta ? item.ch_tipo_consulta : atendimento.marcacao.ch_tipo_consulta ) : ''"
                  @refresh="load"
                  @assinar="assinar"
                  @compartilhar="compartilhar_order"
                  :atendimento="atendimento"
                  :tem_prescricao="tem_prescricao"
                  :tem_infusao="tem_infusao"
                  :tem_solic_consulta="tem_solic_consulta"
                  :prescricao_suspender="prescricao_suspender"
                  :receita_medicamento_buscar="receita_medicamento_buscar"
                  :integracao_ymunity="integracao_ymunity">
                  <!-- Remover -->
                  <button class="btn btn-outline-danger btn-sm ml-2" type="button" v-if="index" @click="removerProcedimento (item)">Remover</button>

                  <!-- Atendimento Pausado -->
                  <template v-if="atendimento.marcacao && atendimento.marcacao.item_status.valor == 'pausado'">
                    <button type="button" class="btn btn-outline-success btn-sm ml-2" @click="retomarAtendimento()"
                      v-if="atendimento.marcacao && ( !atendimento.marcacao.item_status.finalizado || atendimento.marcacao.item_status.valor == 'concluido' )">
                      <i class="fa fa-play" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="btn btn-danger btn-sm ml-2" @click="selecionarFinalizar()"
                        v-if="atendimento.marcacao && ( !atendimento.marcacao.item_status.finalizado || atendimento.marcacao.item_status.valor == 'concluido' )">
                        <span class="d-block d-lg-none">
                          <i class="fas fa-power-off"></i>
                        </span>
                        <span class="d-none d-lg-block">
                          <i class="fas fa-power-off mr-2"></i> 
                          Finalizar Atendimento
                        </span>
                      </button>
                  </template>

                  <template v-else>

                    <!-- Tempo -->
                    <button class="btn btn-outline-secondary btn-sm mx-2 text-nowrap" type="button"
                      data-toggle="tooltip" data-placement="top" title="Duração do Atendimento" v-if="!atendimento.fl_avulso && tempo">
                      <pre class="mb-1"><i class="fas fa-stopwatch mr-2"></i>{{ tempo }}</pre>
                    </button>

                    <!-- Compartilhar Documentos -->
                    <button type="button" class="btn btn-success btn-sm ml-1 mr-1"
                      data-toggle="tooltip" data-placement="top" title="Compartilhar documentos com o paciente"
                      v-if="( documentos_certificados && documentos_certificados.length ) || ( modelos_pre && modelos_pre.length )" @click="enviarParaPaciente()">
                      <span class="d-block d-lg-none">
                          <i class="fa fa-share" aria-hidden="true" v-if="!compartilhando"></i>
                          <div class="spinner-border spinner-border-sm" role="status" v-else>
                            <span class="sr-only">Loading...</span>
                          </div>
                      </span>
                      <span class="d-none d-lg-block">
                        <i class="fa fa-share mr-2" aria-hidden="true" v-if="!compartilhando"></i>
                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                          <span class="sr-only">Loading...</span>
                        </div>
                        Compartilhar
                      </span>
                    </button>

                    <!-- Finalizar Atendimento -->
                    <template v-if="atendimento_iniciado()">
                      <button type="button" class="btn btn-outline-danger btn-sm mr-1" @click="pausarAtendimento()" title="Pausar Atendimento"
                        v-if="pode_pausar && atendimento.marcacao && ( !atendimento.marcacao.item_status.finalizado || atendimento.marcacao.item_status.valor == 'concluido' )">
                        <i class="fa fa-pause" aria-hidden="true"></i>
                      </button>

                      <!-- Cancelar Atendimento -->
                      <template v-if="
                          atendimento.pode_alterar_prontuario && ( 
                            atendimento.fl_avulso || atendimento.marcacao 
                          )">
                        <button type="button" class="btn btn-outline-danger btn-sm mr-1" @click="cancelarProntuario()" title="Cancelar Atendimento">
                          <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                      </template>
                    
                      <button type="button" class="btn btn-danger btn-sm" @click="selecionarFinalizar()"
                        v-if="atendimento.marcacao && ( !atendimento.marcacao.item_status.finalizado || atendimento.marcacao.item_status.valor == 'concluido' )">
                        <span class="d-block d-lg-none">
                          <i class="fas fa-power-off"></i>
                        </span>
                        <span class="d-none d-lg-block">
                          <i class="fas fa-power-off mr-2"></i> 
                          Finalizar Atendimento
                        </span>
                      </button>

                      <button type="button" class="btn btn-danger btn-sm ml-2" @click="selecionarFinalizar()"
                        v-else-if="atendimento.origem && atendimento.origem.marcacao 
                          && ( !atendimento.origem.marcacao.item_status.finalizado || atendimento.origem.marcacao.item_status.valor == 'concluido' )">
                        <span class="d-block d-lg-none">
                          <i class="fas fa-power-off"></i>
                        </span>
                        <span class="d-none d-lg-block">
                          <i class="fas fa-power-off mr-2"></i> 
                          Finalizar Atendimento
                        </span>
                      </button>
                    </template>

                    <template v-else-if="atendimento.marcacao && atendimento.dt_inicio.substr(0,10) == $util.hoje()">
                      <button type="button" class="btn btn-success btn-sm ml-2" @click="iniciarAtendimento()">
                        <i class="fa fa-play" aria-hidden="true"></i>
                      </button>
                    </template>

                  </template>

                  <!-- Cancelar Atendimento -->
                  <template v-if="atendimento.pode_alterar_prontuario && ( 
                        atendimento.fl_avulso || ( 
                          atendimento.marcacao && ( atendimento.marcacao.item_status.finalizado && atendimento.marcacao.item_status.valor != 'concluido' )
                        )
                      )">

                    <button type="button" class="btn btn-outline-danger btn-sm ml-3" @click="cancelarProntuario()">
                      <i class="fa fa-times mr-2" aria-hidden="true"></i>
                      Cancelar Atendimento
                    </button>

                    <button type="button" class="btn btn-outline-danger btn-sm ml-1" @click="reabrirProntuario()"
                      v-if="!atendimento.fl_avulso && ( atendimento.dt_inicio.substr(0,10) == $util.hoje() && acesso_como_medico() )">
                      <i class="fa fa-play mr-2" aria-hidden="true"></i>
                      Reabrir
                    </button>
                  </template>
                </anamnese>
              </template>
            </div>

            <div class="mb-3" v-else-if="item.laudo">
              <div class="card">
                <div class="card-body">
                  <az-editor v-model="teste" editorStyle="height: 320px" />
                </div>
              </div>

              <pre v-if="1 == 0">{{ item.laudo }}</pre>
            </div>

            <div class="mb-3" v-else>
              <div class="alert alert-light">
                <button class="btn btn-outline-danger btn-sm ml-3" type="button">Remover</button>
              </div>
            </div>

            <div>&nbsp;</div>
          </div>

          <div class="tab-pane fade" :class="registro_pep ? 'show active' : ''" id="registro" role="tabpanel">
            <template v-if="registro_pep">
                <template v-if="registro_pep.fl_consultorio">
                    <registro-nota-pep 
                        v-if="registro_pep"
                        :validate="validate"
                        v-model="registro_pep" 
                        :marcacao="atendimento.marcacao"
                        :atendimento_procedimento="atp_first"
                        :id_paciente="atendimento.id_paciente"
                        @refresh="load"
                        :atendimento="atendimento" />
                </template>

                <div class="bg-white" v-else>
                    <div v-for="(registro, rix) in atendimento.registros" :key="rix" class="p-3">
                        <az-sub-title :title="titulo_registro(registro, true)"></az-sub-title>
                        <campos-formulario 
                            v-model="registro.st_conteudo" 
                            :raiz="true" 
                            mode="view"
                            :compact="registro.modelo.fl_compact" />
                    </div>
                </div>
            </template>
          </div>

          <div class="tab-pane fade" id="receita" role="tabpanel">
            <div class="mt-3">
                <pep-lista-order-set 
                    :atendimento="atendimento" 
                    :lista_receita="lista_receita"
                    @assinar="assinar"
                    @compartilhar="compartilhar_order" />
            </div>
          </div>

          <div class="tab-pane fade" id="requisicao" role="tabpanel">
            <div class="mt-3">
                <pep-lista-order-set 
                    :atendimento="atendimento" 
                    :lista_receita="lista_requisicao"
                    @assinar="assinar"
                    @compartilhar="compartilhar_order" />
            </div>
          </div>

          <div class="tab-pane fade" id="lista-documentos" role="tabpanel">
            <div class="mt-3">
                <pep-lista-documento
                    :atendimento="atendimento" 
                    :lista_documentos="lista_documentos"
                    @assinar="assinar"
                    @compartilhar="compartilhar_order" />
            </div>
          </div>

          <div class="tab-pane fade" id="add" role="tabpanel">
            <pre>{{ atendimento }}</pre>
          </div>
        </div>

      </div>

      <div v-if="cancelados && cancelados.length">
        <ul class="list-group">
          <li class="list-group-item disabled">Atendimentos Cancelados</li>
          <li class="list-group-item d-flex justify-content-between small text-muted" v-for="(cancelado, icx) in cancelados" :key="icx">
            <a href="#" @click.prevent="ver_cancelado(cancelado)" class="card-link">
              {{ cancelado.procedimento.search }}
              
              <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
              <i class="fa fa-plus-square" aria-hidden="true"></i>
              {{ $util.getFormatDate(cancelado.dt_inclusao) }}
              {{ cancelado.dt_inclusao.substr(11,5) }}

              <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
              <i class="fa fa-minus-square" aria-hidden="true"></i>
              {{ $util.getFormatDate(cancelado.dt_alteracao) }}
              {{ cancelado.dt_alteracao.substr(11,5) }}

              <span class="badge badge-secondary ml-3" v-if="cancelado.tipo == 'L'">{{ cancelado.tipo }}</span>
            </a>

            <az-audit-log-button model="anamnese" :id="cancelado.id_anamnese" sizing="sm" :link="true" />
          </li>
        </ul>
        
      </div>

    </div>

    <pre v-if="false">{{ atendimento.marcacao.item_status }}</pre>

    <!-- Barra histórico lateral -->

    <div class="sticky-sidebar bg-white w3-animate-left" style="width: 300px;" v-if="ver_historico">

      <div class="px-2">

        <div>
          <az-input
            ref="input_historico"
            sizing="sm"
            icon="fa fa-search fa-fw"
            placeholder="Pesquisar..."
            v-model="search_historico" 
            @onArrowUp="navegar_historico(false)"
            @onArrowDown="navegar_historico(true)"
            @input="conteudo = null; selecionado = null;">
            <template v-slot:buttonposb>
              <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="busca_avancada = !busca_avancada" title="Filtro Avançado">
                  <i class="fa-solid fa-filter" v-if="!busca_avancada"></i>
                  <i class="fa-solid fa-filter-circle-xmark" v-else></i>
                </button>
                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="abrir_historico()" title="Fechar histórico">
                  <i class="fas fa-arrow-left"></i>
                </button>
                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="abrir_perfil()" title="Histórico Detalhado">
                  <i class="fas fa-id-badge"></i>
                </button>
              </div>
            </template>
          </az-input>

          <az-input 
            sizing="sm"
            type="select"
            icon="fa-solid fa-filter fa-fw"
            :optionsList="[
              { id: 'C', search: 'Classse do Procedimento' }, 
              { id: 'E', search: 'Especialidade' }, 
              { id: 'M', search: 'Nome do Profissional' }, 
              { id: 'P', search: 'Nome do Procedimento' }, 
              { id: 'U', search: 'Unidade' }, 
            ]"
            optionsData="id"
            v-if="busca_avancada"
            v-model="filtro_avancado_historico">
            <template v-slot:buttonposb>
              <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="abrir_selecao_lista()" title="Listar">
                  <i class="fa-solid fa-list-check"></i>
                </button>
              </div>
            </template>
          </az-input>
        </div>

        <az-loading msg="Carregando..." v-if="$store.state.loading && !historico_carregado" />

        <template v-else>

          <div class="card overflow-auto" :style="'height: ' + ( busca_avancada ? '68vh;' : '72vh;' )">
            <div class="card-body p-0">
              <div class="list-group">
                <!-- Lista de Atendimentos -->
                <a href="#" class="list-group-item list-group-item-action small" 
                  @keydown.up.prevent="navegar_historico(false)"
                  @keydown.down.prevent="navegar_historico(true)"
                  :id="'hist' +  iix"
                  :class="( !legado && iix == selecionado ) ? 'active' : ( marcacao.atendimento ? '' : 'list-group-item-secondary' )" @click.prevent="selecionar(marcacao, iix)"
                  v-for="(marcacao, iix) in lista_historico_exibicao.marcacoes" :key="iix">
                  <template v-if="marcacao.id_atendimento == atendimento.id_atendimento">
                    <h5 class="strong mb-0">Atendimento Em Edicão</h5>
                  </template>
                  <div>
                      <span class="font-weight-bold">{{ getHumanDate(marcacao.dt_inicio) }}</span>
                      <small class="ml-2">{{ getHumanDuration(marcacao.dt_inicio) }}</small>
                      <span class="ml-2 text-danger" v-if="marcacao.procedimento.id_classe_procedimento == 1 && marcacao.ch_tipo_consulta == 'R'">
                        <i class="fa-solid fa-registered"></i>
                      </span>
                  </div>
                  <div>
                      <strong :class="( !legado && iix == selecionado ) ? '' : 'text-primary'">{{ marcacao.procedimento.search }}</strong>
                      <span v-if="marcacao.st_regiao" class="small ml-2" :class="( !legado && iix == selecionado ) ? 'text-white' : 'text-muted'">{{ marcacao.st_regiao }}</span>
                  </div>
                  <div v-if="marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos && marcacao.atendimento.atendimento_procedimentos.length > 1 && marcacao.atendimento.atendimento_procedimentos.length <= 10">
                      <!-- Outros procedimentos em execução -->
                      <span class="badge badge-pill ml-1 h4" :class="'badge-' + atp.laudo.status_laudo.st_color" 
                            style="font-size: 90%;"
                            :title="atp.procedimento.st_procedimento + ' / ' + atp.laudo.status_laudo.search"
                            v-for="(atp, ilx) in marcacao.atendimento.atendimento_procedimentos.filter(item => item.laudo && item.procedimento.st_sigla)" :key="ilx">
                            {{ atp.procedimento.st_sigla }}
                      </span>
                  </div>
                  <div>
                      {{ marcacao.medico.st_nome_exibicao }}
                      <pep-item-micro-resumo :marcacao="marcacao" v-if="marcacao.id_atendimento != atendimento.id_atendimento" />
                  </div>
                </a>

                <!-- Lista de Atendimentos Legados -->
                <a href="#" class="list-group-item list-group-item-action small" 
                  :id="'legado' + iix"
                  :class="( legado && iix == selecionado ) ? 'active' : ''" @click.prevent="selecionar(item, iix, true)"
                  v-for="(item, iix) in lista_historico_exibicao.legado" :key="'legado' + iix">
                  <div>
                      {{ getHumanDate(item.dt_data) }} 
                      <small class="ml-2">{{ getHumanDuration(item.dt_data) }}</small>
                      <i class="fas fa-history ml-2"></i>
                  </div>
                  <div>{{ item.st_descricao }}</div>
                  <div>{{ item.st_nome_medico }}</div>
                </a>
              </div>
            </div>
          </div>
        </template>

      </div>
    </div>

    <!-- Lista de Itens -->
    <div class="modal fade" id="listaSelecaoHistoricoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Lista de {{ filtro_avancado_historico == 'U' ? 'Unidades' : ( filtro_avancado_historico == 'M' ? 'Profissionais' : 'Procedimentos' ) }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="alert alert-primary d-flex justify-content-between" v-if="search_historico">
              <div>
                {{ search_historico }}
              </div>

              <div>
                <a href="#" @click.prevent="selecionar_atendimento_lista()">
                  <i class="fa-solid fa-xmark"></i>
                </a>
              </div>
            </div>

            <table class="table table-sm border-0 table-responsive">
                <tr>
                    <td class="text-nowrap">
                        <a href="#" @click.prevent="selecionar_unidade_filtro_historico(unid)" v-for="(unid, icx) in lista_historico_unidades" :key="icx">
                            <span class="badge badge-success mr-1" >
                                {{ unid }}
                            </span>
                        </a>
                    </td>
                </tr>
            </table>

            <table class="table table-sm border-0 table-responsive" v-if="lista_historico_classes && lista_historico_classes.length">
                <tr>
                    <td class="text-nowrap">
                        <a href="#" @click.prevent="selecionar_classe_filtro_historico(classe)" v-for="(classe, icx) in lista_historico_classes" :key="icx">
                            <span class="badge badge-success mr-1" >
                                {{ classe }}
                            </span>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-row mb-3">
                <div class="col col-12" :class="search_historico_manter ? 'col-md-6' : ''">
                    <az-input
                        sizing="sm"
                        type="checkbox-group"
                        label="Manter filtro para outros pacientes"
                        v-model="search_historico_manter" />
                </div>

                <div class="col col-12 col-md-6" v-if="!!search_historico_manter">
                    <az-input
                        sizing="sm"
                        type="button-group"
                        :optionsList="[
                            { id: 'A', search: 'Apenas' },
                            { id: 'E', search: 'Exceto' }
                        ]"
                        optionsData="id"
                        v-model="search_historico_manter_escopo" />
                </div>
            </div>

            <az-input 
              sizing="sm"
              type="button-group"
              :optionsList="[
                { id: '', search: 'Todos' }, 
                { id: '1', search: 'Consultas' },
                { id: '2', search: 'Cirurgias' }, 
                { id: '4', search: 'Exames' }, 
                { id: '6', search: 'Procedimentos' }, 
              ]" 
              v-model="filtro_categ" />

            <table class="table table-sm table-hover mt-3 mb-0">
              <thead>
                <tr>
                  <th>Descrição</th>
                  <th>Qtde</th>
                  <th>De</th>
                  <th>Até</th>
                  <th>Último</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(atp, iax) in lista_itens_historico.filter(item => !filtro_categ || item.id_classe_procedimento == filtro_categ)" :key="iax">
                  <td>{{ atp.descr }}</td>
                  <td>{{ atp.qtde }}</td>
                  <td>
                    {{ $util.getFormatDate(atp.dt_min) }}
                    <div class="small text-muted">
                      {{ $util.getHumanDuration(atp.dt_min.slice(0,10)) }}
                    </div>
                  </td>
                  <td>
                    {{ $util.getFormatDate(atp.dt_max) }}
                    <div class="small text-muted">
                      {{ $util.getHumanDuration(atp.dt_max.slice(0,10)) }}
                    </div>
                  </td>
                  <td>
                    <a href="#" @click.prevent="selecionar_atendimento_lista(atp)">
                      #{{ atp.id_atendimento }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <pre v-if="false">{{ lista_itens_historico }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Fim Barra Histórico -->

    <hr>
    <div class="text-center">
      <a href="#" class="card-link" @click.prevent="tour()">
        <i class="far fa-compass fa-2x"></i>
      </a>
      <br><br><br><br><br>
    </div>

    <!-- Modal de Finalização de Atenimdento -->
    <div class="modal fade" id="finalizarAtendimentoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered2" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Finalizar Atendimento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4>Confirma finalizar o atendimento?</h4>
            <div v-if="documentos_certificados && documentos_certificados.length">
              <az-input
                class="mt-3"
                type="checkbox-group"
                label="Enviar documentos assinados para o paciente."
                v-model="enviar_docs" />
              
              <az-input
                class="mt-3"
                type="email"
                label="e-mail"
                v-if="enviar_docs"
                v-model="atendimento.paciente.cadastro.st_email" />
            </div>

            <template v-if="precisa_finalizar_laudo">
              <az-input
                class="mt-3"
                type="checkbox-group"
                label="Fechar Laudo Pronto para Entrega"
                v-model="info_fechar_laudo" />

              <az-input
                v-if="info_fechar_laudo"
                type="checkbox-group"
                label="Registrar Entrega do Laudo"
                v-model="info_registrar_entrega" />

              <az-input 
                class="mt-3"
                v-if="info_registrar_entrega"
                label="Entregue Para"
                required
                :validate="validate"
                v-model="info_entregue_para">
                <template v-slot:buttonposb>
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                      @click="info_entregue_para = ( atendimento.paciente.st_nome_social ? atendimento.paciente.st_nome_social : atendimento.paciente.st_nome )">
                      <i class="fas fa-equals mr-2"></i>
                      Paciente
                    </button>
                  </div>
                </template>
              </az-input>
            </template>

            <template v-if="filaLaudo && filaLaudo.fl_pos_atendimento && $store.state.user.id_pessoa != atendimento.id_medico">
              <!-- // && consultorio_pausado -->  
              <az-input
                type="checkbox-group"
                label="Não retornar para o médico"
                v-model="filaLaudo.encerrar" />                
            </template>

            <template v-if="cid_obrig && edicao_cid">
              <az-input 
                class="mt-3"
                label="CID" 
                sizing="sm"
                type="autocomplete" 
                optionsMode="aql" 
                service="cids.index" 
                optionsData="id_cid" 
                optionsDisplay="search"
                v-model="edicao_cid.id_cid" 
                required
                :validate="validate"  />
            </template>

            <template v-if="dados_atualizar_paciente && dados_atualizar_paciente.length"> 
                <hr>
                <div>Atualizar Cadastro do Paciente:</div>
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between" v-for="(campo, icx) in dados_atualizar_paciente" :key="icx">
                        <div>
                            <input type="checkbox" v-model="campo.selec" class="mr-2" />
                            {{ campo.label ? campo.label : campo.id }}
                        </div>
                        <div>
                            <span v-if="!campo.value">Sem Valor</span>
                            <span v-else>{{ campo.type == 'date' ? $util.getFormatDate(campo.value) : campo.value }}</span>
                        </div>
                    </li>
                </ul>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <az-submit @click="finalizar ()">Confirmar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="lembreteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="show_lembrete">
          <div class="modal-header">
            <h5 class="modal-title">Lembrete</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input type="textarea" v-model="st_lembrete" />

            <div v-if="atendimento.marcacao" class="form-row mt-2">
                <div class="col col-12">
                    <az-input 
                        label="Sinalizador de Atendimento"
                        type="select" 
                        optionsMode="aql"
                        service="sinalizadores.index"
                        :optionsParm="{ ativos: true }"
                        optionsData="id_sinalizador_atendimento"
                        v-model="atendimento.marcacao.id_sinalizador_atendimento">
                    </az-input>
                </div>
            </div>
          </div>
          <div class="modal-footer">
            <az-submit color="outline-danger" @click="removerLembrete ()" v-if="atendimento.lembrete && atendimento.lembrete.id_lembrete">Remover</az-submit>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="atualizarLembrete ()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="addProcedimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Adicionar Procedimento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="atendimento && novoProcedimento">
            <procedimentos
              ref="proced"
              :idMarcacao="atendimento.marcacao.id_marcacao"
              :consultorio="true"
              :assistencia="$route.meta.enfermagem"
              :validate="validate"
              :posUpdate="procedimentosIncluidos"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="incluirProcedimento ()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="sharePrescrModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Compartilhar com o paciente</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-column">

              <div class="mb-2" v-if="atendimento">
                <az-input
                  type="email"
                  icon="far fa-envelope fa-fw"
                  placeholder="Não informado"
                  v-model="atendimento.paciente.cadastro.st_email" />
                <az-input
                  type="fone"
                  icon="fa fa-mobile fa-fw"
                  placeholder="Não informado"
                  :edicao2="false"
                  v-model="atendimento.paciente.cadastro.telefones.celular" />

                <label class="form form-control" v-if="1==0">
                  <i class="far fa-envelope mr-2" aria-hidden="true"></i>
                  {{ ( atendimento && atendimento.paciente.cadastro.st_email ) ? atendimento.paciente.cadastro.st_email : 'Não disponível' }}
                </label>
                <label class="form form-control" v-if="1==0">
                  <i class="fa fa-mobile mr-2" aria-hidden="true"></i>
                  {{ ( atendimento && atendimento.paciente.cadastro.telefones.celular ) ? telefone(atendimento.paciente.cadastro.telefones.celular) : 'Não disponível' }}
                </label>
              </div>

              <div class="d-flex flex-column mb-3">
                <button type="button" class="btn btn-outline-primary" @click="enviar_para_paciente()"
                    v-if="atendimento && atendimento.paciente.cadastro.st_email">
                    <i class="far fa-envelope mr-2"></i>
                    Enviar por e-mail
                </button>
                <a class="btn btn-outline-info mt-2" href="#" @click.prevent="enviar_para_paciente_telegram()" target="_blank" 
                    v-if="atendimento && atendimento.paciente.cadastro.st_telegram_chat_id && !tem_modelos_pre_selecionados">
                    <i class="fab fa-telegram-plane mr-2"></i>
                    Enviar pelo Telegram
                </a>
                <a class="btn btn-outline-success mt-2" @click.prevent="enviar_para_paciente_whatsapp()" target="_blank" 
                    v-if="atendimento && atendimento.paciente.cadastro.telefones.celular && !tem_modelos_pre_selecionados">
                    <i class="fa fa-whatsapp mr-2" aria-hidden="true"></i> Enviar pelo WhatsApp
                </a>
                <a class="btn btn-outline-dark mt-2" href="#" @click.prevent="copiar_texto_share()" v-if="atendimento && !tem_modelos_pre_selecionados">
                    <i class="fas fa-copy mr-2"></i> Copiar texto do compartilhamento
                </a>
              </div>

              <div v-if="docs_para_compartilhar" class="mb-3">
                <ul class="list-group">
                  <li class="list-group-item" v-for="(dpc, imx) in docs_para_compartilhar" :key="imx">
                    <input type="checkbox" v-model="dpc.selecionado" class="mr-3">
                    <span>{{ dpc.titulo }}
                        <span class="badge badge-secondary ml-2" v-if="dpc.qtd > 1">{{ dpc.qtd }}</span>
                    </span>
                  </li>
                </ul>
              </div>
              
              <div v-if="modelos_pre && modelos_pre.length > 0" class="mb-3">
                <ul class="list-group">
                  <li class="list-group-item" v-for="(mod, imx) in modelos_pre" :key="imx">
                    <input type="checkbox" v-model="mod.selecionado" class="mr-3">
                    <span>{{ mod.search }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <assinar-p-e-p ref="assinador" :tem_certificado="( atendimento && atendimento.medico && atendimento.medico.tem_certificado ) ? true : false" />

    <resultados ref="resultados" name="edicao" @direita="ver_barra_direita($event)" />

    <speech-rec ref="speech" />

    <gallery-preview ref="gallery" />

    <pep-item-cancelado-view ref="pepcanc" @abrir_doc_view="abrir_doc_view" />

    <consultorio-fila-procedimento ref="filaproc" />

    <alergia ref="alergia" @refresh="load()" />

    <conta-modal ref="conta" :atendimento="atendimento" />

    <!-- Modal -->
    <div class="modal fade" id="recorrenciaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="atendimento && atendimento.marcacao && atendimento.marcacao.recorrencias">
          <div class="modal-header">
            <h5 class="modal-title">Recorrência</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <span class="badge badge-primary mr-2" v-for="(item, idx) in atendimento.marcacao.recorrencias" :key="idx">
              {{ $util.getFormatDate(item) }}
            </span>

            <div class="mt-3">
              <az-input 
                sizing="sm"
                type="button-group" 
                optionsData="id"
                :optionsList="[
                  { id: 'M', search: 'Manter Tratamento' }, 
                  { id: 'E', search: 'Encerrar Tratamento' }, 
                ]" 
                v-model="tratamento" />
            </div>

            <p class="alert alert-warning mt-3" v-if="tratamento == 'E'">Com o encerramento do tratamento, as demais agendas desse paciente listadas acima serão canceladas.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit v-if="tratamento == 'E'" @click="confirmar_encerramento()">Confirmar Encerramento</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Visualização de Documentos -->
    <div class="modal fade" id="docViewModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="doc">
          <div class="modal-header">
            <h5 class="modal-title">{{ doc.st_titulo }}</h5>
              <button type="button" class="close" @click="fechar_modal('docViewModal')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <doc-view :view="true" :doc="doc" />
          </div>
          <div class="modal-footer" v-if="doc">
            <az-submit @click="$util.print_preview('imprimir/documento/' + doc.id_documento_atendimento, true)">Imprimir</az-submit>
            <button type="button" class="btn btn-secondary" @click="fechar_modal('docViewModal')">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal CID -->
    <div class="modal fade" id="edicaoCidModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" v-if="edicao_cid">
          <div class="modal-header">
            <h5 class="modal-title">CID</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="mb-2">
                <az-input 
                    label="CID" 
                    sizing="sm"
                    type="autocomplete" 
                    optionsMode="aql" 
                    service="cids.index" 
                    optionsData="id_cid" 
                    optionsDisplay="search"
                    v-model="edicao_cid.id_cid" 
                    :validate="validate">
                    <template v-slot:buttonposb>
                        <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="favoritar('cid', edicao_cid.id_cid)">
                            <i class="fas fa-star"></i>
                        </button>
                        </div>
                    </template>
                </az-input>
            </div>

            <favoritos ref="favcid" @selecionar="selecionar_cid_fav" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="atualizar_cid()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal CID Histórico -->
    <div class="modal fade" id="selecionarCidHistoricoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">CIDs do Paciente</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="progress mb-3">
              <div class="indeterminate" v-if="$store.state.loading"></div>
              <div class="determinate" v-else></div>
            </div>

            <template v-if="!historico_carregado">
              <p class="alert alert-info">Carregando...</p>
            </template>

            <div class="list-group" v-else>
              <p class="alert alert-info" v-if="!Object.keys(lista_de_cids).length">
                Nenhum CID identificado.
              </p>

              <button type="button" class="list-group-item list-group-item-action" v-for="(itens, cid, icx) in lista_de_cids" :key="icx"
                @click="selecionar_cid(itens[0].atendimento.cid)" :disabled="$store.state.loading">
                <div>{{ cid }}</div>  
                <div>{{ itens[0].procedimento.search }}</div>
                <div>{{ itens[0].medico.search }}</div>
                <div>
                  {{ $util.getFormatDate(itens[0].dt_inicio) }}
                  <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                  #{{ itens[0].id_atendimento }}
                </div>
              </button>
            </div>
            <pre class="alert alert-warning mt-3" v-if="false">{{ lista_de_cids }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Histórico Lateral -->
    <div class="sticky-sidebar-right bg-white w3-animate-right" style="width: 300px;" v-if="visualizcao_historico_lateral && resultado_fixo_direita">

      <az-loading msg="Carregando..." v-if="$store.state.loading && !historico_carregado" /> 

      <div class="px-2" v-else>

        <div>
          <az-input
            sizing="sm"
            icon="fa fa-search"
            placeholder="Pesquisar..."
            v-model="search_historico" 
            @input="conteudo = null; selecionado = null;">
            <template v-slot:buttonposb>
              <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="abrir_perfil()">
                  <i class="fas fa-id-badge"></i>
                </button>
                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="abrir_historico(true)">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
                <print-export sizing="sm" printid="historico-resumo" />
              </div>
            </template>
          </az-input>
        </div>

        <div id="historico-resumo">

          <cabecalho-generico titulo="Histórico">
            <div>Paciente: {{ atendimento.paciente.st_nome }}</div>
            <div>Data: {{ $util.getFormatDate($util.hoje()) }}</div>
          </cabecalho-generico>

          <div class="card">
            <template v-for="(marcacao, iix) in lista_historico_exibicao.marcacoes">
              <template v-if="marcacao.id_atendimento != atendimento.id_atendimento">
                <div class="list-group-item list-group-item-info p-2" :key="iix">
                  <div class="small d-flex justify-content-between">
                      <span>{{ getHumanDate(marcacao.dt_inicio) }}</span>
                      <span class="ml-2 d-print-none">{{ getHumanDuration(marcacao.dt_inicio) }}</span>
                  </div>
                  <div class="small">
                      {{ marcacao.procedimento.search }}
                  </div>
                  <div class="small">
                      {{ marcacao.medico.st_nome_exibicao }}
                  </div>
                  <div class="small" v-if="marcacao.atendimento && marcacao.atendimento.cid">
                      CID: {{ marcacao.atendimento.cid.st_codigo }}
                  </div>
                </div>
                <template v-if="marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos">
                  <div v-for="(atp, itx) in marcacao.atendimento.atendimento_procedimentos" :key="iix + '.' + itx"> 

                    <div class="mb-3" v-if="!atp.laudo">
                      <formulario 
                        :onecol="true"
                        v-model="atp.anamnese.dados" 
                        mode="view" 
                        :view_with_print="false" 
                        tamanho="P" 
                        :secundario="marcacao.id_procedimento != atp.id_procedimento || ( marcacao.atendimento.registros && marcacao.atendimento.registros.length )" 
                        v-if="atp.anamnese" />
                    </div>

                    <div class="mb-3" v-else-if="resumo_com_laudo && atp.laudo">
                        <formulario 
                            :onecol="true"
                            v-model="atp.laudo.dados" 
                            mode="view" 
                            :view_with_print="false" 
                            tamanho="P" 
                            :secundario="marcacao.id_procedimento != atp.id_procedimento" 
                            v-if="atp.laudo" />
                    </div>

                    <template v-if="marcacao.atendimento.registros && marcacao.atendimento.registros.length">

                      <div v-for="(registro, iregx) in marcacao.atendimento.registros" :key="iregx">
                          <div v-if="registro.st_conteudo && registro.st_conteudo.length">
                              <az-sub-title :title="titulo_registro(registro)">
                              </az-sub-title>

                              <campos-formulario 
                                  v-model="registro.st_conteudo" 
                                  :raiz="true" 
                                  mode="view"
                                  :compact="registro.modelo.fl_compact" />
                          </div>
                      </div>

                  </template>
                  </div>
                </template>
              </template>
            </template>

            <!-- Lista de Atendimentos Legados -->
            <template v-for="(item, iix) in lista_historico_exibicao.legado">
              <div  v-if="item.st_tipo == '1'" :key="'leg' + iix">
                <div class="list-group-item list-group-item-info" :key="'legado' + iix">
                  <div class="small">
                      {{ getHumanDate(item.dt_data) }} 
                      <small class="ml-2">{{ getHumanDuration(item.dt_data) }}</small>
                      <i class="fas fa-history ml-2"></i>
                  </div>
                  <div class="small">{{ item.st_descricao }}</div>
                  <div class="small">{{ item.st_nome_medico }}</div>
                </div>
                <div class="mb-3" :key="'legado-cont' + iix">
                  <span v-html="item.st_conteudo" class="small"></span>
                </div>
              </div>
            </template>
          </div>

        </div>

        <br><br><br><br><br>
        
      </div>

    </div>

  </div>

  <order-set
        v-if="edicao_prescricao"
        title="Prescrição"
        v-model="edicao_prescricao"
        service="medicamentos.index"
        :tem_infusao="false"
        name="receita"
        ref="prescricao_protocolo"
        :id_anamnese="edicao_prescricao_base.id_anamnese"
        :atendimento="atendimento"
        :id_paciente="atendimento.id_paciente"
        @refresh="load()"
        :validprescr="true"
    ></order-set>

    <audio-transcription-modal 
        ref="audioTranscription" 
        :atendimento="atendimento" />

</div>
</template>

<script>
import * as moment from "moment";
import $ from "jquery";
import _ from "lodash";
import FichaPaciente from "../../shared/FichaPaciente.vue";
import Anamnese from "./Anamnese.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzEditor from '../../shared/forms/AzEditor.vue';
import Procedimentos from "../recepcao/Procedimentos.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import LembretePaciente from "./LembretePaciente.vue";
import AzVideoCall from '../../shared/zoom/AzVideoCall.vue';
import AssinarPEP from './AssinarPEP.vue';
import AzLoading from '../../util/AzLoading.vue';
import Resultados from './Resultados.vue';
import PreAtendimentoView from './PreAtendimentoView.vue';
import SpeechRec from '../../shared/speech/SpeechRec.vue';
import GalleryPreview from '../../shared/gallery/GalleryPreview.vue';
import PepItemCanceladoView from './PepItemCanceladoView.vue';
import PepItemMicroResumo from './PepItemMicroResumo.vue';
import PepViewCard from './PepViewCard.vue';
import PepViewCardLegado from './PepViewCardLegado.vue';
import DocView from './DocView.vue';
import LaudoEditor from '../laudos/LaudoEditor.vue';
import AtendimentoEnfermagemItem from '../enfermagem/AtendimentoEnfermagemItem.vue';
import RetornoAtendimento from './RetornoAtendimento.vue';
import Formulario from './Formulario.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import ConsultorioFilaProcedimento from './ConsultorioFilaProcedimento.vue';
//import VisualizarLaudoExterno from './VisualizarLaudoExterno.vue';
import AnexarLaudoExterno from '../laudos/AnexarLaudoExterno.vue';
import CamposFormulario from './CamposFormulario.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import RegistroNotaPep from './RegistroNotaPep.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Alergia from './Alergia.vue';
import ContaModal from './ContaModal.vue';
import VerArquivosRolagem from './VerArquivosRolagem.vue';
import DoctorAssistant from './DoctorAssistant.vue';
import Favoritos from '../../shared/Favoritos.vue';
import PepListaOrderSet from './PepListaOrderSet.vue';
import PepListaDocumento from './PepListaDocumento.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import OrderSet from "./OrderSet.vue";
import AudioTranscriptionModal from '../ai/AudioTranscriptionModal.vue';

export default {
  data() {
    return {
      id_atendimento: null,
      atendimento: null,
      teste: "",
      st_lembrete: "",
      tipo_lembrete: "A",
      novoProcedimento: "",
      tmaFim: "",
      tmaInterval: null,
      validate: false,
      video: false, 
      compartilhando: false, 
      order_set_stats: {}, 
      enviar_docs: true, 
      tratamento: "M", 
      motivo_encerramento: "", 
      tem_prescricao: false, 
      tem_solic_consulta: false, 
      tem_infusao: false, 
      ver_historico: false,
      historico_carregado: false, 
      lista_historico: {}, 

      conteudo: null, 
      selecionado: null,
      legado: false,  
      search_historico: "", 
      search_historico_manter: false, 
      search_historico_manter_escopo: "A", 

      doc: null, 
      enf_modelos: null, 

      rechamado: false, 
      pode_pausar: false, 
      tem_gravacao_video: false, 

      info_fechar_laudo: false, 
      info_registrar_entrega: false, 
      info_entregue_para: "", 
      cid_obrig: false, 

      edicao_cid: null, 

      resultado_fixo_direita: false, 
      filaLaudo: null, 

      visualizcao_historico_lateral: false, 
      instrucoes: null,

      resumo_com_laudo: false, 
      modelos_pre: null, 
      docs_para_compartilhar: null, 

      busca_avancada: false, 
      filtro_avancado_historico: "P", 
      filtro_categ: "", 
      lista_itens_historico: [],

      pode_gerar_orcamento: false,
      texto_compartilhar_documento: "",
      pep_info_cid: false, 

      block_doc_titulo: false, 
      block_gravar_telemed: false, 

      doctorAssistentInit: false, 
      doctorAssistent: false,

      prescricao_suspender: false, 
      receita_medicamento_buscar: false, 
      daai_ativo: false, 

      dados_atualizar_paciente: null, 
      id_fila_proc: null, 

      edicao_prescricao: null, 
      edicao_prescricao_base: null,

      integracao_ymunity: false, 
      show_lembrete: false, 
    };
  },

  props: ["id", "fila"],

  components: {
    FichaPaciente,
    Anamnese,
    AzInput,
    AzSubmit,
    Procedimentos,
    LembretePaciente,
    AzVideoCall,
    AssinarPEP,
    AzLoading,
    Resultados,
    PreAtendimentoView,
    SpeechRec, 
    GalleryPreview,
    PepItemCanceladoView, 
    PepItemMicroResumo, 
    PepViewCard, 
    PepViewCardLegado,
    DocView,
    LaudoEditor,
    AtendimentoEnfermagemItem, 
    RetornoAtendimento, 
    Formulario, 
    PrintExport, 
    CabecalhoGenerico, 
    ConsultorioFilaProcedimento, 
    AnexarLaudoExterno, 
    CamposFormulario,
    AzSubTitle,
    RegistroNotaPep, 
    AzEditor, 
    AzAuditLogButton, 
    Alergia, 
    ContaModal, 
    VerArquivosRolagem, 
    DoctorAssistant, 
    Favoritos, 
    PepListaOrderSet, 
    PepListaDocumento,
    RegistrarContatos,  
    OrderSet, 
    AudioTranscriptionModal, 
  },

  computed: {
    lista_historico_unidades: function () { 
        if ( !this.lista_historico || !this.lista_historico.marcacoes )
            return [];

        return _.uniq(
            this.lista_historico.marcacoes.map(item => item.unidade_operacao ? item.unidade_operacao.st_sigla : "")
                .filter(item => item)
                .sort()
            );
    },

    lista_historico_classes: function () { 
        if ( !this.lista_historico || !this.lista_historico.marcacoes )
            return [];

        return _.uniq(
            this.lista_historico.marcacoes.flatMap(item => item.procedimento && item.procedimento.js_classes ? item.procedimento.js_classes : [])
                .filter(item => item)
                .sort()
        );
    },

    lista_receita: function () { 
        if ( !this.atendimento && this.atendimento.atendimento_procedimentos ) { 
            return []; 
        }

        return this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese 
            ? item.anamnese.receita 
            : [] );
    },

    lista_requisicao: function () { 
        if ( !this.atendimento && this.atendimento.atendimento_procedimentos ) { 
            return []; 
        }

        return this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese 
            ? item.anamnese.requisicao 
            : [] );
    },

    lista_documentos: function () { 
        if ( !this.atendimento && this.atendimento.atendimento_procedimentos ) { 
            return []; 
        }

        return this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese 
            ? item.anamnese.documentos 
            : [] );
    },

    is_dev: function () { 
        return window.redir == 'teste';
    },

    is_cirurgia: function () { 
      return _.get(this.atendimento, 'marcacao.procedimento.id_classe_procedimento') == 2;
    },

    sala_video: function () { 
      if ( !this.atendimento ) { 
        return;
      }

      if ( this.atendimento.marcacao && this.atendimento.marcacao.video_sala ) { 
        return this.atendimento.marcacao.video_sala.slice(
          this.atendimento.marcacao.video_sala.indexOf('-') + 1
        );
      }

      return 'pac-' + this.atendimento.id_paciente;
    },

    links_documentos_compartilhaveis: function () {
      let links = this.documentos_certificados 
      ? this.documentos_certificados.filter(item => !this.docs_para_compartilhar
            || this.docs_para_compartilhar.find(dpc => dpc.model == item.model.type 
                && ( !dpc.model_id || dpc.model_id == item.model.id )
                && dpc.selecionado )
        )
        .reduce((total, item) => {
            return total = total + item.doc_certificado_link + "\n" + "\n";
        }, "")
      : "";

      if ( this.docs_para_compartilhar && this.docs_para_compartilhar.length ) {
        let linksPacs = this.docs_para_compartilhar
          .filter(item => item.selecionado && item.url)
          .map(item => item.url)
          .join("\n\n");

        if ( linksPacs ) {
          links = links + linksPacs + "\n\n";
        }
      }

      return links;

    },

    lista_links_documentos_compartilhaveis: function () {
      let links = this.documentos_certificados.filter(item => !this.docs_para_compartilhar
          || this.docs_para_compartilhar.find(dpc => dpc.model == item.model.type 
            && ( !dpc.model_id || dpc.model_id == item.model.id )
            && dpc.selecionado)
      )
      .map(item => {
        return { 
          url: item.doc_certificado_link,
          titulo: _.get(item, 'model.type', 'documento'), 
        };
      });

      if ( this.docs_para_compartilhar && this.docs_para_compartilhar.length ) {
        let linksPacs = this.docs_para_compartilhar
          .filter(item => item.selecionado && item.url)
          .map(item => {
            return {
              url: item.url,
              titulo: item.titulo ? item.titulo : 'documento',
            };
          });

        if ( linksPacs.length ) {
          links = links.concat(linksPacs);
        }
      }

      return links;

    },

    texto_mensagem: function () {

      // let nl = "%0D%0A";
      let nl = "\n";
      let msg = "Prezado(a) ";

      if(this.texto_compartilhar_documento) {
        return this.texto_compartilhar_documento;
      }

      msg = msg + this.atendimento.paciente.st_nome;
      msg = msg + nl;
      msg = msg + "Links para os documentos gerados no atendimento:" + nl;
      msg = msg + this.links_documentos_compartilhaveis;

      msg = ( this.$store.state.unidade.st_nome_sms 
        ? this.$store.state.unidade.st_nome_sms + nl
        : this.$store.state.unidade.search + nl ) + msg;

      return msg;

    },


    tem_modelos_pre_selecionados: function () { 
      if ( !this.modelos_pre || !this.modelos_pre.length ) 
        return false;

      return this.modelos_pre.find(item => item.selecionado) ? true : false;
    },

    registro_pep: function () { 
      return _.first(this.atendimento.registros, reg => reg.fl_consultorio);
    },

    atp_first: function () { 
      return _.first(this.atendimento.atendimento_procedimentos);
    },

    lista_de_cids: function () { 
        if ( !this.historico_carregado )
            return [];

        if ( !this.lista_historico || !this.lista_historico.marcacoes )
            return [];

        return _.groupBy(
            _.orderBy(
                this.lista_historico.marcacoes.filter(item => _.get(item, 'atendimento.cid.st_codigo')), 
                'dt_inicio',
                'desc'
            ), 
            'atendimento.cid.st_codigo'
        );
    },

    precisa_finalizar_laudo: function () { 

      if ( this.atendimento && this.atendimento.atendimento_procedimentos && !this.$route.meta.vacina ) { 

        let teste = this.atendimento.atendimento_procedimentos.find(item => item.laudo 
          && item.laudo.status_laudo && !item.laudo.status_laudo.fl_pronto);

        return teste ? true : false;

      }

      return false;

    }, 

    lista_historico_exibicao: function () { 
        if ( !this.search_historico )
            return this.lista_historico;

        if ( !this.lista_historico || !this.lista_historico.marcacoes ) { 
            return this.lista_historico; 
        }

        let busca_positiva = true; // !( this.search_historico && this.search_historico.slice(0, 1) == '-');

        let reg = this.$util.getregex(this.search_historico);

        let teste = { 
            marcacoes: this.lista_historico.marcacoes.filter(item => { 

                if ( !this.search_historico )
                return true;

                let descr = "";

                if ( this.busca_avancada ) { 
                    switch (this.filtro_avancado_historico) {
                        case 'U':
                            if ( item.unidade_operacao  ) { 
                                descr = item.unidade_operacao.st_sigla;
                            } else { 
                                descr = '???';
                            }    
                            break;

                        case 'E':
                            descr = _.get(item, 'procedimento.especialidade.search');
                            break;

                        case 'P':
                            if ( item.atendimento && item.atendimento.atendimento_procedimentos ) { 
                                descr = item.atendimento.atendimento_procedimentos.map(item => item.procedimento.search).join(',');
                            } else { 
                                descr = item.procedimento.search;
                            }    
                            break;

                        case 'M':
                            descr = item.medico.search;
                            break;

                        case 'C': 
                            if ( item.procedimento && item.procedimento.js_classes ) { 
                                descr = JSON.stringify(item.procedimento.js_classes);
                            } else { 
                                descr = '???';
                            }    
                            break;

                        default: 
                            descr = JSON.stringify(item);
                            break;
                    }             
                } 

                return item.id_atendimento == this.atendimento.id_atendimento 
                    || ( ( !this.busca_avancada || this.filtro_avancado_historico == 'G' ) && reg.test(JSON.stringify(item)))
                    || ( this.busca_avancada 
                        && this.filtro_avancado_historico != 'G' 
                        && descr 
                        && ( ( busca_positiva && reg.test(descr) ) || ( !busca_positiva && !reg.test(descr) ) )
                    );
            }),

            legado: this.lista_historico.legado.filter(item => { 
                if ( !this.search_historico )
                    return true;
                
                let descr = "";

                if ( this.busca_avancada ) { 
                    switch (this.filtro_avancado_historico) {
                        case 'P':
                            descr = item.st_descricao;
                            break;

                        case 'M':
                            descr = item.st_nome_medico;
                            break;
                    }             
                } 

                return ( !this.busca_avancada && reg.test(JSON.stringify(item)) )
                    || ( this.busca_avancada && descr && reg.test(descr));
            }),
        };

        return teste;
    },

    cancelados: function () { 
      if ( !this.atendimento ) 
        return[];

      return _.orderBy(
        this.atendimento.atendimento_procedimentos.flatMap(item => 
          item.anamneses_canceladas.map(ac => { 
            return { 
              ...ac,
              tipo: 'A', 
              procedimento: item.procedimento, 
            };      
          })
          .concat(!item.laudos_cancelados ? [] : item.laudos_cancelados.map(ld => { 
              return { 
                ...ld,
                tipo: 'L', 
                procedimento: item.procedimento, 
              };      
            })
          )
        ),
        'id_anamnese'
      );
    },

    pode_alterar: function () { 
      return ( this.atendimento && this.atendimento.pode_alterar_prontuario && !this.atendimento.pode_alterar_prontuario.pode ) ? false : true;
    },

    tempo: function() {
      if (!this.atendimento) return "";

      let fim = this.atendimento.medico_end
        ? this.atendimento.medico_end
        : this.tmaFim;

      if (fim) {
        let now = moment(
          this.atendimento.medico_end
            ? this.atendimento.medico_end
            : this.tmaFim,
          this.atendimento.medico_end 
            ? "YYYY-MM-DD HH:mm:ss"  
            : "HH:mm:ss"
        );
        let end = moment(this.atendimento.medico_start, "YYYY-MM-DD HH:mm:ss");
        let diff = now.diff(end);

        let duration = moment.utc(diff).format("HH:mm:ss");

        if ( duration.substr(0,3) == '00:' ) { 
          duration = duration.substr(3,5);
        }

        return duration;
      }

      return "";
    },

    documentos_certificados: function () {

      if ( !this.atendimento )
        return [];

      let lista = [];

      this.atendimento.atendimento_procedimentos.forEach(atp => {

        if ( atp.anamnese ) { 

          if ( atp.anamnese.doc_certificado ) {
            let doc_anamnese = _.cloneDeep(atp.anamnese.doc_certificado);
            doc_anamnese.model = { type: 'anamnese', id: atp.anamnese.id_anamnese };
            doc_anamnese.titulo = atp.procedimento.search;
            doc_anamnese.doc_certificado_link = atp.anamnese.doc_certificado_link;

            console.log('doc_anamnese', doc_anamnese);
            
            lista.push(doc_anamnese);
          }

          atp.anamnese.receita.forEach(item => {
            if ( item.doc_certificado ) {
              lista.push(_.cloneDeep(item));
            }
          });

          atp.anamnese.requisicao.forEach(item => {
            if ( item.doc_certificado ) {
              lista.push(_.cloneDeep(item));
            }
          });

          atp.anamnese.atestados.forEach(item => {
            if ( item.doc_certificado ) {
              lista.push(_.cloneDeep(item));
            }
          });

          atp.anamnese.documentos.forEach(item => {
            if ( item.doc_certificado ) {
              lista.push(_.cloneDeep(item));
            }
          });

          if ( atp.laudo ) { 
            if ( atp.laudo.doc_certificado ) {
              lista.push(_.cloneDeep(atp.laudo));
            }
           
          }

        }
        
      });

      return lista;

    },

    consultorio_pausado: function () { 
      if ( !this.atendimento )
        return false;

      let prog = _.last(
        this.atendimento.progresso_atendimentos.filter(item => [5,6,7,9,10].find(et => et == item.id_etapa_atendimento))
      );

      return ( prog && prog.id_etapa_atendimento == 9 );
    },
  },

  methods: {
    selecionar_unidade_filtro_historico (unid) { 
        this.search_historico = unid; 
        this.filtro_avancado_historico = 'U';

        $('.modal').modal('hide');
    },

    selecionar_classe_filtro_historico (classe) { 
        this.search_historico = ( classe && ( this.search_historico_manter_escopo == 'E' ) ? '-' : '' ) + classe; 
        this.filtro_avancado_historico = 'C';

        this.$util.setCookie('pep-sh', this.search_historico_manter ? '[C]' + this.search_historico : '');

        $('.modal').modal('hide');
    },

    editar_prescricao_protocolo (marcacao) { 

        let receita = marcacao.infusao.protocolo.receita;
        
        this.edicao_prescricao_base = _.cloneDeep(receita);
        this.edicao_prescricao = receita.editada ? _.cloneDeep(receita.editada) : _.cloneDeep(receita);

        this.edicao_prescricao.tipo_edicao = 'P';
        this.edicao_prescricao.id_marcacao_edicao = null; // marcacao.id_marcacao;
            
        this.$nextTick(() => { 
            this.$refs.prescricao_protocolo.abrir(this.edicao_prescricao);
        });

    },

    quando (data) { 
        if ( data && data.slice(0,10) == this.$util.hoje() ) { 
            return 'Hoje'
        } else { 
            return this.$util.getFormatDate(data, 'DD/MM');
        }
    },  
    
    consultar_contatos (type, id, receita) { 
        this.$refs.contatos.visualizar(type, id, receita, true);
    },

    selecionar_cid_fav(cid) { 
        this.edicao_cid.id_cid = cid.id_cid;
        this.atualizar_cid();
    },

    favoritar (model_type, model_id) { 
        let model = {
            model_type: model_type, 
            model_id: model_id,
        };

        this.$util.loadItem(this, { 
            service: 'favoritos',
            func: 'favoritar',
            parms: model, 
        })
        .then(() => {
            this.$refs.favcid.carregar(model_type, true);
        });

    },

    tem_prescricao_infusao (anamnese) { 

        if ( anamnese && anamnese.receita && anamnese.receita.find(receita => receita.fl_ativo && receita.fl_prescricao && receita.fl_ciclos) ) { 
            return true; 
        }

        return false;

    },

    compartilhar_order (order) { 
        this.enviarParaPaciente(order);
    },

    toggleDoctorAssistent () { 
        if ( window.redir == 'teste' ) { 
            this.$refs.audioTranscription.abrir();
            return; 
        }

        this.doctorAssistentInit = true; 
        this.doctorAssistent = !this.doctorAssistent;

        console.log('refs', this.$refs);

        this.$nextTick(() => { 
            if ( this.$refs.daai ) { 
                this.$refs.daai.iniciar();
            } else { 
                this.$toast.add({
                    severity: "warn",
                    summary: "DAAI",
                    detail: "Componente não identificado.",
                    life: 3000
                });   
            }
        });

        $('[data-toggle="tooltip"]').tooltip('hide');
    },

    naoComparecer(atd) { 
      if ( !confirm('Confirma registrar o não comparecimento do paciente para o procedimento?') ) 
        return;

      this.$util.atualizar(this, { 
        service: 'atendimentos',
        func: 'pausar',
        dados: { 
          id: atd.id_atendimento, 
          nao_compareceu: true, 
          fila: this.fila, 
        },
        callback: () => { 
          this.ir_para_lista();
        }
      });

    },

    lembrete_pac() { 
      this.conteudo = null;
      this.selecionado = null;
      this.legado = false;

      this.$nextTick(() => { 
        this.$refs.lembretepac.editar();
      });
    },

    preencher_formularios (campos, titulo) { 

        if ( !campos ) { 
            return; 
        }

        if ( !confirm("Confirma preencher o formulário com os dados de '" + titulo + "'?") ) { 
            return;
        }

        let valores = this.$utilform.obter_campos(campos);

        if ( this.$store.state.user.id_usuario == 1 ) { 
            console.log('valores', valores);
        }

        this.atendimento.atendimento_procedimentos.forEach(atp => { 
            if ( atp.anamnese && atp.anamnese.dados ) { 
                this.$utilform.preencher_campos(atp.anamnese.dados, valores);
            }

            if ( atp.laudo && atp.laudo.dados ) { 
                this.$utilform.preencher_campos(atp.laudo.dados, valores);
            }
        });

        this.atendimento.registros.forEach(reg => { 
            if ( reg.edicao && reg.pode_editar && reg.st_conteudo ) { 
                this.$utilform.preencher_campos(reg.st_conteudo, valores);
            }
        });

        this.$toast.add({
            severity: "success",
            summary: "Atualizar",
            detail: "Atualização realizada.",
            life: 3000
        });

    },

    vincular_ao_paciente () { 
      this.$util.atualizar (this, { 
        service: 'pacientes',
        func: 'toggle_classe', 
        dados: { 
          id_paciente: this.atendimento.id_paciente,
          classe: this.atendimento.cid.st_codigo, 
        },
        toast: true, 
        callback: res => { 
          if ( res && _.get(res, 'paciente.paciente_unidade.js_classes') ) { 
            this.atendimento.paciente.paciente_unidade.js_classes = res.paciente.paciente_unidade.js_classes;
          }
        }
      });
    },

    toggle_ver_anexos_laudo (item) { 
      item.laudo.ver_anexos = !item.laudo.ver_anexos;

      this.$forceUpdate();
    },

    abrir_orcamento () { 
      this.$router.push({ path: '/consultorio/orcamento/' + this.atendimento.id_atendimento });
    },

    selecionar_atendimento_lista(opcao = null) { 
      this.search_historico = ( opcao ? opcao.descr : '' );

      this.$util.setCookie('pep-sh', this.search_historico_manter ? this.search_historico : '');

      $('#listaSelecaoHistoricoModal').modal('hide');

      this.$nextTick(() => { 
        if ( opcao ) { 
          let index = this.lista_historico_exibicao.marcacoes.findIndex(item => item.id_atendimento == opcao.id_atendimento);

          if ( index > 0 || index === 0 ) { 
            this.selecionar(this.lista_historico_exibicao.marcacoes[index], index);
          }
        }
      });
    },

    abrir_selecao_lista() { 
      
      if ( !this.lista_historico || !this.lista_historico.marcacoes ) { 
        this.lista_itens_historico = [];
      } else { 
        
        let base = this.lista_historico.marcacoes.filter(item => item.atendimento && item.id_atendimento != this.atendimento.id_atendimento)
          .flatMap(item => item.atendimento.atendimento_procedimentos.map(atp => { 
            return { 
              ...atp,
              dt_inicio: item.dt_inicio, 
            };
          }));

        this.lista_itens_historico = _.orderBy(
          _.map(
            _.groupBy(base, 'id_procedimento'),
            (itens) => { 
              return { 
                id: _.get(itens, '0.procedimento.id_procedimento'),
                descr: _.get(itens, '0.procedimento.search'), 
                qtde: itens.length, 
                dt_min: _.minBy(itens, 'dt_inicio').dt_inicio,
                dt_max: _.maxBy(itens, 'dt_inicio').dt_inicio,
                id_atendimento: _.maxBy(itens, 'dt_inicio').id_atendimento,
                selec: false, 
                id_classe_procedimento: _.get(itens, '0.procedimento.id_classe_procedimento'), 
              }
            }
          ),
          'descr'
        );
      }

      $('#listaSelecaoHistoricoModal').modal('show');
    },

    abrir_alergias () { 
      this.$refs.alergia.abrir(this.atendimento.id_paciente);
    },

    ir_para_pacientes() { 
        if ( this.verificar_nao_salvo() ) { 
            return;
        }

        let destino = ( this.$route.meta.vacina ) 
                ? '/vacina' 
                : ( 
                    ( this.$route.meta.enfermagem || this.fila ) 
                    ? '/assistencia/atend' 
                    : ( this.$route.meta.internacao ? '/internacao/internados' : '/consultorio' ) 
                );

        if ( destino == '/consultorio' ) { 
            this.$router.push({ name: "consultorio", params: { dt: this.atendimento ? this.atendimento.dt_inicio : null } });
        } else {            
            this.$router.push({ path: destino, params: { dt: this.atendimento ? this.atendimento.dt_inicio : null } });
        }
    },
    
    acesso_como_medico () { 
      if ( !this.atendimento ) { 
        return false;
      }

      if ( this.atendimento.id_medico == this.$store.state.user.id_pessoa ) { 
        return true;
      }

      if ( !this.$store.state.user.medico && this.$store.state.user.delegantes_medicos.find(deleg => deleg.delegante.id_pessoa == this.atendimento.id_medico) ) { 
        return true;
      }

      return false;
    },

    copiar_texto_share (acao = null) { 
        this.$util.loadItem(this, {
            service: 'pep',
            func: 'gerar_texto_compartilhar_documento',
            parms: {
                id_atendimento: this.id_atendimento,
                links: this.links_documentos_compartilhaveis
            }
        }).then(res => {
            if ( res && res.block_lista ) { 
                this.texto_compartilhar_documento = null;  
            } else { 
                this.texto_compartilhar_documento = res;
            }

            this.$nextTick(() => { 
                if ( !acao ) { 
                    this.$util.copiar_clipboard(this, this.texto_mensagem, 'Texto para compartilhamento copiado.');
                } else { 
                    acao (this.texto_mensagem);
                }
            });
        });
    },

    navegar_historico(down = false) { 
      // ( !selecionado && selecionado !== 0 ) ? selecionado = 0 : selecionado ++
      
      if ( !this.legado ) { 

        if ( down ) { 
          if ( this.selecionado === null ) { 
            if ( this.lista_historico_exibicao && this.lista_historico_exibicao.marcacoes.length ) { 
              this.selecionar(this.lista_historico_exibicao.marcacoes[0], 0);
            }
          } else { 
            if ( this.lista_historico_exibicao && this.lista_historico_exibicao.marcacoes.length > this.selecionado + 1 ) { 
              this.selecionar(this.lista_historico_exibicao.marcacoes[this.selecionado + 1], this.selecionado + 1);
            } else if ( this.lista_historico_exibicao && this.lista_historico_exibicao.marcacoes.length == this.selecionado + 1 ) { 
              if ( this.lista_historico_exibicao.legado.length ) { 
                this.selecionar(this.lista_historico_exibicao.legado[0], 0, true);
              }
            }
          } 
        } else if ( this.selecionado > 0 ) { 
          this.selecionar(this.lista_historico_exibicao.marcacoes[this.selecionado - 1], this.selecionado - 1);
        }

      } else { 

        if ( down ) { 
          if ( this.lista_historico_exibicao && this.lista_historico_exibicao.legado.length > this.selecionado + 1 ) { 
            this.selecionar(this.lista_historico_exibicao.legado[this.selecionado + 1], this.selecionado + 1);
          }
        } else if ( this.selecionado > 0 ) { 
          this.selecionar(this.lista_historico_exibicao.legado[this.selecionado - 1], this.selecionado - 1);
        } else if ( this.lista_historico_exibicao && this.lista_historico_exibicao.marcacoes.length ) { 
          this.selecionar(this.lista_historico_exibicao.marcacoes[this.lista_historico_exibicao.marcacoes.length - 1], this.lista_historico_exibicao.marcacoes.length - 1, false);
        }
        
      }
    },

    listar_cids() { 
      $('#selecionarCidHistoricoModal').modal('show');

      if ( !this.historico_carregado ) { 
        this.carregar_historico();
      }
    },

    titulo_registro(registro, force_nome = false) { 
        if ( force_nome ) { 
            return _.get(registro, 'modelo.st_modelo_prontuario', 'Notas') + ', '
                + _.get(registro, 'usuario.pessoa.st_nome') + ', ' 
                + ( !registro.created_at ? 'Novo' : registro.created_at.substr(11,5) );
        }

        if ( registro.fl_consultorio ) { 
            return _.get(registro, 'modelo.st_modelo_prontuario', 'Notas');
        }

        return _.get(registro, 'usuario.pessoa.st_nome') + ', ' + 
            ( !registro.created_at ? 'Novo' : registro.created_at.substr(11,5) );
    },

    abrir_historico_lateral() { 
      this.abrir_historico(true);
    },

    abrir_perfil() { 
      this.$root.perfil(this.atendimento.paciente);
    },

    ver_barra_direita(ver) { 
      this.resultado_fixo_direita = ver;
    },

    selecionar_cid (cid) { 
      this.edicao_cid = { 
        id_atendimento: this.atendimento.id_atendimento,
        id_cid: cid.id_cid, 
      };

      this.atualizar_cid('selecionarCidHistoricoModal');
    },

    atualizar_cid (modal = null) { 
      this.$util.atualizar(this, { 
        service: 'pep',
        func: 'atualizar_cid',
        dados: this.edicao_cid,
        modal: modal ? modal : 'edicaoCidModal',
        callback: cid => { 
          this.atendimento.cid = cid;
          this.atendimento.id_cid = cid ? cid.id_cid : null;
        }
      });
    },

    editar_cid () { 
        this.validate = false;

        this.edicao_cid = { 
            id_atendimento: this.atendimento.id_atendimento,
            id_cid: this.atendimento.id_cid, 
        };

        this.$nextTick(() => { 
            this.$refs.favcid.carregar('cid');
        });
        
        $('#edicaoCidModal').modal('show');
    },

    ir_para_lista() { 
      if ( this.$route.meta.vacina ) { 
        this.$router.push({ path: "/vacina" });
      } else if ( this.$route.meta.enfermagem && this.$route.meta.cc ) { 
        this.$router.push({ path: "/centro-cirurgico/atendimento" });
      } else if ( this.$route.meta.enfermagem || this.fila ) { 
        this.$router.push({ path: "/assistencia/atend" });
      } else if ( this.$route.meta.internacao ) { 
        this.$router.push({ path: "/internacao/internados" });
      } else { 
        this.$router.push({ name: "consultorio", params: { dt: this.atendimento ? this.atendimento.dt_inicio : null } });
      }
    },

    atendimento_iniciado () { 
      let progressos;

      if ( this.atendimento && this.atendimento.marcacao && this.atendimento.progresso_atendimentos) { 

        progressos = this.atendimento.progresso_atendimentos;

      } else if ( this.atendimento && this.atendimento.origem && this.atendimento.origem.marcacao
        && this.atendimento.origem.marcacao.atendimento ) { 

        progressos = this.atendimento.origem.marcacao.atendimento.progresso_atendimentos;

      }

      if ( !progressos ) {
        return false;
      }

      return progressos.find(item => { 
                if ( !this.fila ) { 
                    if ( item.fila && item.fila.fl_fila_paralela ) { 
                        return false;
                    }
                }

                return item.id_etapa_atendimento == 6;
            }) 
            ? true 
            : false;
    },

    removerRetorno (ret) { 
      if ( !confirm('Confirma remover o retorno programado?') ) 
        return;

      let retorno = _.cloneDeep(ret);

      retorno.fl_ativo = false;

      this.$util.atualizar(this, { 
        service: 'retorno_atendimentos',
        dados: retorno,
        toast: true, 
        callback: () => { 
          this.load();
        }
      });
    },

    pausarAtendimento() { 
      if ( this.$util.getCookie('cn-ncf') == 'S' ) { 
        // 
      } else { 
        if ( !confirm('Confirma pausar o atendimento do paciente?') ) 
          return;
      }

      this.$util.atualizar(this, { 
        service: 'atendimentos',
        func: 'pausar',
        no_validate: true, 
        dados: { 
          id: this.atendimento.id_atendimento, 
          fila: this.fila, 
        },
        callback: () => { 
          this.ir_para_lista();
          // this.$router.push({ name: "consultorio" });
        }
      });

    },

    iniciarAtendimento() { 
      if ( !confirm('Confirma iniciar o atendimento do paciente?') ) 
        return;

      this.$util.atualizar(this, { 
        service: 'atendimentos',
        func: 'iniciar',
        dados: { 
          id: this.atendimento.id_atendimento, 
          internacao: this.$route.meta.internacao, 
          fila: this.fila, 
        },
        callback: () => { 
          this.load();
        }
      });

    },

    retomarAtendimento() { 
      if ( this.$util.getCookie('cn-ncf') == 'S' ) { 
        // 
      } else { 
        if ( !confirm('Confirma retomar o atendimento do paciente?') ) 
          return;
      }

      this.$util.atualizar(this, { 
        service: 'atendimentos',
        func: 'retomar',
        no_validate: true, 
        dados: { 
          id: this.atendimento.id_atendimento, 
          fila: this.fila, 
        },
        callback: () => { 
          this.load();
        }
      });

    },

    chamarNovamente (marcacao) { 
      $('[data-toggle="tooltip"]').tooltip('hide');

      if ( !confirm('Confirma re-enviar a chamada do paciente?') )
        return;

      this.rechamado = true;
      this.chamar(marcacao);
    },

    chamar (marcacao) { 

      this.$store.commit('loading', true);

      let query = { q: [
        { 
          name: "atendimentos.chamar",
          id: "chamada",
          parms: { 
            id: marcacao.id_atendimento, 
            id_recepcao: this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null,
            local: this.$util.getCookie('local-chamada'),
            block_painel: this.$util.getCookie('nao-enviar-painel'),  
            fila: this.fila, 
          }
        }
      ]};

      this.axios.post('/aql?a=ratendimentos.chamar', query)
        .then(res => { 
          //console.log(res);

          if ( res.data.chamada.status == 200 ) { 
            this.$store.commit('loading', false);

            const msg = res.data.chamada.data.msg ? res.data.chamada.data.msg.msg : "Chamada re-enviada.";
            const severity = res.data.chamada.data.msg && res.data.chamada.data.msg.status_code > 400 ? 'warn' : 'success';

            if ( this.rechamado ) { 
              this.$toast.add({
                severity: severity,
                summary: "Chamar",
                detail: msg,
                life: 3000
              });
            }
          }
        })
        .finally (() => { 
          this.$store.commit('loading', false);
        });

    },

    retornarAoAtendimento (atendimento) { 
      this.$router.replace({ path: '/consultorio/res/' + atendimento.id_atendimento + '/' + ( this.fila ? this.fila : '' )});
      this.conteudo = null;
      this.id_atendimento = atendimento.id_atendimento;
      this.atendimento = null;

      this.$nextTick(() => {
        this.load();
      });
    },

    status_laudo (laudo, fechar = false) { 
      this.$util.atualizar(this, { 
        service: 'laudos',
        func: 'status',
        dados: { 
          id_laudo: laudo.id_laudo,
          consultorio: true, 
          fechar: fechar, 
        },
        callback: () => { 
          this.load();
        }
      });
    },

    cancelar_assinatura_laudo (laudo) { 
      if ( !confirm('Confirmar cancelar a assinatura do laudo?') )
        return;

      this.$util.atualizar(this, { 
        service: 'laudos',
        func: 'cancelar_assinatura',
        dados: { 
          id_laudo: laudo.id_laudo, 
        },
        toast: true,
        callback: () => { 
          this.load();
        }
      })
    },

    eh_laudo(item) { 
      return item && item.laudo && ( !item.anamnese.st_anamnese || item.laudo.st_laudo );
    },

    eh_laudo_texto_rico(item) { 
      return item && item.laudo && ( !item.anamnese.st_anamnese || item.laudo.st_laudo )
        && item.laudo.dados && item.laudo.dados.length == 1 && item.laudo.dados[0].type == 'rich';
    },

    fechar_modal(modal) { 
      $('#' + modal).modal('hide');
    },

    abrir_doc_view(doc) { 
      this.doc = doc;
      $('#docViewModal').modal('show');
    },

    selecionar(item, index, legado = false) { 
        this.selecionado = index;
        this.legado = legado;
        
        let el = document.getElementById(( legado ? 'legado' : 'hist' ) + index);

        if ( el ) { 
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        if ( item.id_atendimento == this.atendimento.id_atendimento ) { 
          this.conteudo = null;
        } else { 
          this.conteudo = item;
        }

        //console.log('Conteudo', this.conteudo);
    },

    getHumanDay(date) {
        return moment(date, "YYYY-MM-DD").format("dddd");
    },

    getHumanDate(date) {
        return (
            moment(date, "YYYY-MM-DD").format("DD") +
            " de " +
            moment(date, "YYYY-MM-DD").format("MMMM") +
            (moment(date, "YYYY-MM-DD").format("YYYY") == new Date().getFullYear()
            ? ""
            : " de " + moment(date, "YYYY-MM-DD").format("YYYY"))
        );
    },

    getHumanDuration(date) {
        if (date.substr(0, 10) == this.$util.hoje()) 
            return "hoje";
        else {
          moment.relativeTimeRounding(Math.floor);
          return moment.duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje())).humanize(true);
        }
    },

    abrir_historico (lateral_direito = false) { 
      if ( lateral_direito ) { 

        if ( this.visualizcao_historico_lateral ) { 
          this.conteudo = null;
          this.selecionado = null;
          this.resultado_fixo_direita = false;
          this.visualizcao_historico_lateral = false;  

          this.$util.setCookie('pep-hd', 0);
          return;
        }

        this.resultado_fixo_direita = true;
        this.visualizcao_historico_lateral = true;

        this.$util.setCookie('pep-hd', 1);

      } else { 

        if ( this.ver_historico ) { 
          this.conteudo = null;
          this.selecionado = null;
          this.ver_historico = false;

          this.$util.setCookie('pep-he', 0);
          return;
        }

        this.$util.setCookie('pep-he', 1);
        this.ver_historico = true;

      }

      if ( !this.historico_carregado ) { 
        this.carregar_historico();
      }

    },

    carregar_historico () { 

      this.$store.commit("loading", true);
      this.loading = true;
      let query = { q: [] };

      query = {
        q: [
          {
            name: "marcacoes.index",
            id: "marcacoes",
            parms: { id_paciente: this.atendimento.id_paciente, classes: true }
          },
          {
            name: "pep.legado",
            id: "legado",
            parms: { id_paciente: this.atendimento.id_paciente }
          },
          {
            name: "pep.avulsos",
            id: "avulsos",
            parms: { id_paciente: this.atendimento.id_paciente }
          },
          {
            name: "configuracoes.index",
            id: "resumolaudo",
            parms: { 
              where: { 
                st_slug: 'pep-resumo-com-laudo',
                st_valor: '1', 
              }
            }
          },
        ]
      };

      this.axios
        .post("/aql?a=pep.load", query)
        .then(res => {
          this.lista_historico = {};

          this.lista_historico.marcacoes = res.data.marcacoes.data;
          this.lista_historico.legado = res.data.legado ? res.data.legado.data : null;
          
          if ( res.data.avulsos && res.data.avulsos.data.length ) { 
            this.lista_historico.marcacoes = _.orderBy(
              this.lista_historico.marcacoes.concat(res.data.avulsos.data),
              'dt_inicio',
              'desc'
            );
          }

          if ( res.data.resumolaudo && res.data.resumolaudo.data.length ) { 
            this.resumo_com_laudo = true;
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
          this.historico_carregado = true; 
        });

    },

    ver_cancelado(item) { 
      this.$refs.pepcanc.abrir(this.atendimento, item.id_anamnese, item.id_laudo);
    },

    confirmar_encerramento() { 
      this.$util.atualizar(this, { 
        service: 'marcacoes',
        func: 'cancelar_recorrencias',
        dados: { 
          id_marcacao: this.atendimento.marcacao.id_marcacao,
          motivo: 'Tratamento encerrado por ' + this.$store.state.user.pessoa.st_nome, 
        },
        modal: 'recorrenciaModal',
        callback: () => { 
          this.atendimento.marcacao.recorrencias = [];
        }
      });
    },

    recorrencia() { 
      $('#recorrenciaModal').modal('show');
    },

    abrir_galeria_imagens() { 
      this.$refs.gallery.abrir(this.atendimento);
    },

    reconhecer_voz() { 
      this.$refs.speech.abrir();
    },

    resultados(lateral = false) { 
      if ( this.visualizcao_historico_lateral ) { 
        this.abrir_historico (true);
      }

      $('[data-toggle="tooltip"]').tooltip('hide');
      this.$refs.resultados.abrir(this.atendimento, lateral);
    },

    telefone (telefone) { 
      if ( !telefone )
        return "";

      let textoAjustado = "(" + telefone.slice(0,2) + ") ";
      if(telefone.length == 11) {
        const parte1 = telefone.slice(2,7);
        const parte2 = telefone.slice(7,11);
        textoAjustado = textoAjustado + `${parte1}-${parte2}`        
      } else {
        const parte1 = telefone.slice(2,6);
        const parte2 = telefone.slice(6,10);
        textoAjustado = textoAjustado + `${parte1}-${parte2}`
      }

      return textoAjustado;
    },

    assinar (order) { 

        console.log('Assinar', order);

        if ( order.model.type != 'anamnese' && order.model.type != 'laudo' ) { 
            this.validate = false;
        } else { 
            this.validate = true;
        }

        this.$nextTick(() => {
      
            let invalids = $(".invalid");

            if ( this.validate && invalids.length && $(".invalid").is(":visible") ) {

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Verificar preenchimento dos campos.",
                    life: 3000
                });

            } else { 

                this.validate = false;

                this.$refs.assinador.solicitar(
                    order.id_anamnese,
                    order.model.type,
                    order.model.id,
                    () => { 
                    this.load();
                    }
                );

            }

        });

    },

    enviar_para_paciente() {
      this.$util.atualizar(this, { 
        service: 'pep',
        func: 'enviar_para_paciente',
        dados: { 
          id_atendimento: this.atendimento.id_atendimento,
          email: this.atendimento.paciente.cadastro.st_email,
          selecao: this.docs_para_compartilhar ? this.docs_para_compartilhar : true, 
          modelos_pre: this.modelos_pre, 
        },
        modal: "sharePrescrModal",
        callback: () => { 
          this.$toast.add({
            severity: "success",
            summary: "Atualizar",
            detail: "Documentos enviados para o paciente.",
            life: 3000
          });

          if ( process.env.VUE_APP_GTAG ) { 

            let action = 'share-docs-email';
            let label = this.atendimento.id_atendimento;

            this.$gtag.event(action, {
                'event_category': window.redir,
                'event_label': label,
                'value': 1
            });

          }

        }
      });

    },

    enviar_para_paciente_telegram() { 

      this.$util.atualizar(this, { 
        service: 'pep',
        func: 'enviar_para_paciente',
        dados: { 
          id_atendimento: this.atendimento.id_atendimento,
          telegram: true,
        },
        modal: "sharePrescrModal",
        callback: () => { 
          this.$toast.add({
            severity: "success",
            summary: "Atualizar",
            detail: "Documentos enviados para o paciente.",
            life: 3000
          });

          if ( process.env.VUE_APP_GTAG ) { 

            let action = 'share-docs-telegram';
            let label = this.atendimento.id_atendimento;

            this.$gtag.event(action, {
                'event_category': window.redir,
                'event_label': label,
                'value': 1
            });

          }
        }
      });

    },

    enviar_para_paciente_whatsapp() {
      
      if(this.$store.state.user.wa_back) {

        const paciente = this.atendimento.paciente;
        const numero = paciente.cadastro.telefones.celular;

        if (this.$store.state.user.wa_back) {

          this.$util.loadItem(this, {
            service: 'pep',
            func: 'gerar_texto_compartilhar_documento',
            parms: {
              id_atendimento: this.id_atendimento,
              links: this.lista_links_documentos_compartilhaveis,
            }
          })
          .then(res => {

            if ( res ) { 

              let lista = ( res && res.lista && res.lista.length ) 
                ? res.lista
                : [
                  res.msg
                ];

              if ( !lista.find(msg => msg) || res.block_lista ) { 

                this.$util.loadItem(this, { 
                  service: 'pep',
                  func: 'enviar_para_paciente_whatsapp',
                  parms: {
                    mensagem: this.texto_mensagem,
                    nome: paciente.st_nome,
                    numero: numero,
                    pergunta: res.pergunta ? res.pergunta : null,
                    numero_pc: _.get(paciente, 'cadastro.telefones.pc', null),
                  }
                })
                .then(res => { 

                  $('#sharePrescrModal').modal('hide');

                  if(res && res.status_code == 200) {
                    this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: "Mensagem enviada com sucesso",
                            life: 3000
                        });
                  }
                });

              } else { 
                lista.forEach(msg => { 

                  let pergunta = null;
                  if (res && res.pergunta && res.pergunta.placeholders) {
                    // Cria uma cópia de res.pergunta substituindo os placeholders
                    pergunta = {
                        ...res.pergunta,
                        placeholders: msg
                    };
                  }

                  this.$util.loadItem(this, { 
                    service: 'pep',
                    func: 'enviar_para_paciente_whatsapp',
                    parms: {
                      mensagem: msg,
                      nome: paciente.st_nome,
                      numero: numero,
                      pergunta: pergunta,
                      numero_pc: _.get(paciente, 'cadastro.telefones.pc', null),
                    }
                  })
                  .then(res => { 

                    $('#sharePrescrModal').modal('hide');

                    if(res && res.status_code == 200) {
                      this.$toast.add({
                              severity: "success",
                              summary: "Atenção",
                              detail: "Mensagem enviada com sucesso",
                              life: 3000
                          });
                    }
                  });

                });

              }

            }
              
          });

        }

      } else {

        this.copiar_texto_share(() => { 
            let celular = "";
            let msg = encodeURIComponent(this.texto_mensagem);
    
            celular = this.atendimento.paciente.cadastro.telefones.celular;
            
            if (!celular) {
              return "javascript:alert('Celular não disponível')";
            }
    
            celular = "55" + celular;
            window.open("https://wa.me/" + celular + "?text=" + msg, "_blank");
        });

      }

    },

    traduzir_model_type (model_type) { 

        let titulo;

        switch (model_type) {
            case 'receita':
                titulo = 'Receita/Prescrição';
                break;

            case 'requisicao':
                titulo = 'Requisição';
                break;
        }

        return titulo ? titulo : model_type;

    },

    enviarParaPaciente (order) { 

      $('[data-toggle="tooltip"]').tooltip("dispose");
      
      this.compartilhando = true;
      this.docs_para_compartilhar = null;

      if ( order ) { 

        console.log('shareOrder', order);

        this.docs_para_compartilhar = [
            { 
                model: order.model.type,
                model_id: order.model.id,
                qtd: 1,
                titulo: this.traduzir_model_type(order.model.type) + ' / Selecionado(a)',
                selecionado: true, 
            }
        ];

      } else if ( this.documentos_certificados && this.documentos_certificados.length ) { 
        this.docs_para_compartilhar = _.orderBy(
          _.map(
            _.groupBy(
              _.cloneDeep(this.documentos_certificados),
              'model.type'
            ),
            (items, chave) => { 
              let titulo = chave; 
              let selecionado = true;

              switch (chave) {
                case 'anamnese':
                  titulo = items.map(item => item.titulo ? item.titulo : 'Registro Clínico').join(', ');
                  selecionado = false;
                  break;

                case 'receita':
                  titulo = 'Receita/Prescrição';
                  break;

                case 'requisicao':
                  titulo = 'Requisição';
                  break;

                case 'atestado':
                  titulo = 'Atestado';
                  break;

                case 'documentoAtendimento':
                  titulo = 'Documentos';
                  break;

                case 'laudo':
                  titulo = 'Laudo';
                  break;
              }

              return {
                model: chave,
                qtd: items.length,
                titulo: titulo,
                selecionado: selecionado, 
              };
            } 
          ),
          'titulo'
        );
      }

        this.$util.loadItem(this, {
            service: "pacientes",
            id: this.atendimento.id_paciente,
            configs: ['compartilhar-pacs-url-paciente']
        })
            .then(res => {
                if (res.cadastro && res.cadastro.st_email)
                    this.atendimento.paciente.cadastro.st_email = res.cadastro.st_email;

                console.log(this.atendimento);
                console.log(this.$store.state.contexto);

                const compartilharPacs = this.$store.state.contexto["compartilhar-pacs-url-paciente"];
                const atpsConsultarUrl = (compartilharPacs && this.atendimento.atendimento_procedimentos) ?
                    this.atendimento.atendimento_procedimentos.filter(ap => ap.st_pacs == 'OK' && ap.st_an).map(ap => ap.id_atendimento_procedimento)
                    : [];

            
                if (compartilharPacs && atpsConsultarUrl.length > 0) {
                    this.$util.loadItem(this, {
                        service: "pep",
                        func: "pacs_urls_comparilhar",
                        parms: {
                            id_atps: atpsConsultarUrl,
                        }
                    }).then(res => {
                        const links = Array.isArray(res) ? res : (res && res.links ? res.links : []);

                        if (links.length > 0) {
                            if (!this.docs_para_compartilhar) {
                                this.docs_para_compartilhar = [];
                            }

                            this.docs_para_compartilhar = this.docs_para_compartilhar.concat(
                                links.map(item => ({
                                    model: 'atendimentoProcedimento',
                                    model_id: item.id_atendimento_procedimento,
                                    qtd: 1,
                                    titulo: item.titulo,
                                    url: item.url,
                                    selecionado: true,
                                }))
                            );
                                
                        }

                        this.$nextTick(() => {
                            $('#sharePrescrModal').modal('show');
                        });
                    });
                } else {
                    $('#sharePrescrModal').modal('show');
                }
            })
            .finally(() => {
                this.compartilhando = false;
            });
    },

    toggleVideo () { 
      this.video = !this.video;
      $('[data-toggle="tooltip"]').tooltip('hide');
    },

    procedimentosIncluidos() {
      alert("procedimentosIncluidos");
    },

    startCronometro() {
      if (
        this.atendimento &&
        this.atendimento.medico_start &&
        !this.atendimento.medico_end
      ) {
        if (this.tmaInterval) {
          clearInterval(this.tmaInterval);
        }

        this.tmaInterval = setInterval(() => {
          this.tmaFim = moment().format("HH:mm:ss");
        }, 1000);
      }
    },

    removerProcedimento(item) {
      this.$util.atualizar(this, {
        service: "pep",
        func: "remover",
        no_validate: true, 
        dados: {
          id_atendimento_procedimento: item.id_atendimento_procedimento
        },
        callback: () => {
          this.load();
        }
      });
    },

    incluirProcedimento() {
      if (this.$refs.proced.temItemBloqueado()) {
        alert("Item sem cobertura pela operadora.");
        return;
      }

      this.$store.commit("loading", true);

      this.$refs.proced
        .atualizar()
        .then(res => {
          if (res && res.data.retorno.status == 200) {
            this.$util
              .loadItem(this, {
                service: "atendimentos",
                func: "iniciar",
                id: this.atendimento.id_atendimento, 
                fila: this.fila, 
              })
              .then(res => {
                if (res) {
                  this.load();
                  $("#addProcedimentoModal").modal("hide");
                }
              });
          } else if (res && res.data.retorno.status == 290) {
            this.load();
            $("#addProcedimentoModal").modal("hide");
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });

    },

    addProcedimento() {
      this.novoProcedimento = false;

      this.$nextTick(() => {

        this.novoProcedimento = true;

        this.$nextTick(() => {
          this.$refs.proced.carregar();
          $("#addProcedimentoModal").modal("show");
        });

      });
    },

    lembrete() {
        this.show_lembrete = true; 
        this.st_lembrete = this.atendimento.lembrete
            ? this.atendimento.lembrete.st_lembrete
            : "";

        $("#lembreteModal").modal("show");
    },

    atualizarLembrete() {
      let lembrete;

      if (this.tipo_lembrete == "P") {
        lembrete = {
          id_paciente: this.atendimento.id_paciente,
          st_lembrete: this.st_lembrete
        };

        this.$util.atualizar(this, {
          service: "pacientes",
          func: "lembrete",
          dados: { 
            ...lembrete,
          },
          modal: "lembreteModal",
          callback: res => {
            this.atendimento.paciente.paciente_unidade.st_lembrete = res;
          }
        });
      } else {
        if (this.atendimento.lembrete) {
          lembrete = { ...this.atendimento.lembrete };
          lembrete.st_lembrete = this.st_lembrete;
        } else {
          lembrete = {
            id_lembrete: null
          };
        }

        this.$util.atualizar(this, {
          service: "lembretes",
          dados: { 
            ...lembrete,
            id_atendimento: this.atendimento.id_atendimento,
            st_lembrete: this.st_lembrete,
            id_marcacao: this.atendimento.marcacao ? this.atendimento.marcacao.id_marcacao : null,
            id_sinalizador_atendimento: this.atendimento.marcacao ? this.atendimento.marcacao.id_sinalizador_atendimento : null
          },
          modal: "lembreteModal",
          callback: res => {
            if ( res.sinalizador && this.atendimento.marcacao ) { 
                this.atendimento.marcacao.id_sinalizador_atendimento = res.sinalizador.id_sinalizador_atendimento;
                this.atendimento.marcacao.sinalizador_atendimento = res.sinalizador;
            }

            if ( res && res.status_code > 0 ) { 
                // 
            } else { 
                this.atendimento.lembrete = res;
            }
          }
        });
      }
    },

    removerLembrete() {
      if (!confirm("Confirma remover lembrete?")) {
        return;
      }

      this.$util.remover(this, {
        service: "lembretes",
        dados: this.atendimento.lembrete,
        modal: "lembreteModal",
        callback: () => {
          this.atendimento.lembrete = null;
        }
      });
    },

    getFormatDate(date, format) {
      return moment(date, "YYYY-MM-DD").format(format);
    },
    historico() {
      this.$root.perfil(this.atendimento.paciente);
    },
    load() {
      if ( this.$refs.gallery ) { 
        this.$refs.gallery.refresh();
      }
      
      this.$store.commit("loading", true);

      let lista_configs = [ 
        'prescricao-cobranca', 
        'pep-info-cid', 
        'pep-block-gravar-telemed', 
        'prescricao-suspender', 
        'receita-medicamento-buscar', 
        'daai-ativo', 
        'prescricao-apraza-data', 
      ];

      if ( window.redir == 'teste' || window.redir == 'imunobr' || window.redir == 'imunobrteste' ) { 
        lista_configs.push('integracao-ymunity-clientid');
      }

      let query = {
        q: [
          {
            name: "pep.show",
            id: "pep",
            parms: {
              id: this.id_atendimento,
              enfermagem: this.$route.meta.enfermagem, 
              vacina: this.$route.meta.vacina, 
              id_fila_laudo: this.fila, 
              anotacoes: this.$route.params.anotacoes, 
            },
            configs: lista_configs
          },
          {
            name: "usuarios.tem_permissao_acesso",
            id: "gerar_orcamento",
            parms: { resource_id: 158, block_vazio: true }
          },
          {
            name: "pep.gerar_texto_compartilhar_documento",
            id: "gerar_texto_compartilhar_documento",
            parms: { 
                id_atendimento: this.id_atendimento,
                links: this.links_documentos_compartilhaveis
             }
          },
        ]
      };

      this.axios.post("/aql?a=pep.show", query).then(res => {
        if (res.data.pep.status == 200) {
          let atend = res.data.pep.data.atendimento;

          if ( atend.marcacao 
            && atend.marcacao.doc_pre_atends
            && atend.marcacao.doc_pre_atend_outros
            && atend.marcacao.doc_pre_atend_outros.length ) { 

            atend.marcacao.doc_pre_atends = atend.marcacao.doc_pre_atends.concat(
              atend.marcacao.doc_pre_atend_outros
            );

          }

          if ( res.data.configs_pep ) { 
            atend.prescricao_cobranca = res.data.configs_pep['prescricao-cobranca'] ? true : false;
            this.pep_info_cid = res.data.configs_pep['pep-info-cid'] ? true : false;

            this.$store.commit('setContexto', res.data.configs_pep);
          }

          if ( res.data.configs_pep ) { 
            if ( res.data.configs_pep['pep-block-gravar-telemed'] ) { 
              this.block_gravar_telemed = true; 
            }
          }

          if ( res.data.configs_pep ) { 
            if ( res.data.configs_pep['prescricao-suspender'] ) { 
              this.prescricao_suspender = true; 
            }
          }

          if ( res.data.configs_pep ) { 
            if ( res.data.configs_pep['receita-medicamento-buscar'] ) { 
              this.receita_medicamento_buscar = true; 
            }
          }

          if ( res.data.configs_pep ) { 
            if ( res.data.configs_pep['daai-ativo'] ) { 
              this.daai_ativo = true; 
            }
          }

          if ( res.data.configs_pep ) { 
            if ( res.data.configs_pep['integracao-ymunity-clientid'] ) { 
              this.integracao_ymunity = true; 
            }
          }

          if ( res.data.pep.data.internacao ) { 
            atend.internacao = res.data.pep.data.internacao;
          }

          if ( res.data.pep.data.tem_balanco ) { 
            atend.tem_balanco = true;
          }

          if ( res.data.pep.data.tem_aparelho ) { 
            atend.tem_aparelho = true;
          }

          this.atendimento = atend;
          this.tem_prescricao = res.data.pep.data.prescricao;
          this.tem_infusao = res.data.pep.data.infusao;
          this.tem_solic_consulta = res.data.pep.data.solic_consulta;
          this.pode_pausar = res.data.pep.data.pausar;
          this.enf_modelos = res.data.pep.data.modelos;
          this.tem_gravacao_video = res.data.pep.data.gravacao;
          this.info_fechar_laudo = res.data.pep.data.fechar_laudo;
          this.cid_obrig = res.data.pep.data.pep_cid_obrig;
          this.instrucoes = res.data.pep.data.instr;
          this.modelos_pre = res.data.pep.data.modelos_pre;
          this.id_fila_proc = res.data.pep.data.id_fila_proc;
          this.docs_na_consulta = res.data.pep.data.docs_na_consulta;

          if ( res.data.pep.data.reg_pode_edit_data ) { 
            this.atendimento.reg_pode_edit_data = true;
          }

          if ( res.data.pep.data.block_doc_titulo ) { 
            this.block_doc_titulo = true;
          }
          
          this.atendimento.adicoes = res.data.pep.data.adicoes;

          this.pode_gerar_orcamento = res.data.gerar_orcamento ? res.data.gerar_orcamento.data.pode : false;

          if ( this.$route.meta.enfermagem && this.fila ) { 
            this.filaLaudo = res.data.pep.data.fila;
          }

          this.startCronometro();

          if ( this.$route.meta.avulso ) { 
            this.$store.commit("setBreadcrumb", [
              { name: "Avulso", path: "/" },
              { name: this.atendimento.paciente.st_nome, path: "/" }
            ]);
          } else if ( this.$route.meta.vacina ) { 
            this.$store.commit("setBreadcrumb", [
              { name: "Vacina", path: "/vacina" },
              { name: this.atendimento.paciente.st_nome, path: "/vacina/atend" }
            ]);
          } else if ( this.$route.meta.enfermagem && this.$route.meta.cc ) { 
            this.$store.commit("setBreadcrumb", [
              { name: "Centro Cirúrgico", path: '/centro-cirurgico/marcacao' }, 
              { name: "Atendimento", path: '/centro-cirurgico/atendimento' }, 
              { name: this.atendimento.paciente.st_nome, path: "/centro-cirurgico/atend" }
            ]);
          } else if ( this.$route.meta.enfermagem || this.fila ) { 
            this.$store.commit("setBreadcrumb", [
              { name: "Assistência", method: this.ir_para_pacientes }, // path: "/assistencia/atend" },
              { name: this.atendimento.paciente.st_nome, path: "/assistencia/atend" }
            ]);
          } else if ( this.$route.meta.internacao  ) { 
            this.$store.commit("setBreadcrumb", [
              { name: "Internação", path: "/internacao/internados" },
              { name: this.atendimento.paciente.st_nome, path: "/internacao/atendimento" }
            ]);
          } else { 
            this.$store.commit("setBreadcrumb", [
              { name: "Consultório", path: "/consultorio" },
              { name: this.atendimento.paciente.st_nome, path: "/consultorio" }
            ]);
          }

          if ( !this.visualizcao_historico_lateral && this.$util.getCookie('pep-hd') == 1 ) { 
            this.$nextTick(() => { 
              this.abrir_historico_lateral();
            });
          } 
          
          if ( !this.ver_historico && this.$util.getCookie('pep-he') == 1 ) { 
            this.$nextTick(() => { 
              this.abrir_historico();
            });
          }

          //

          if ( res.data.gerar_texto_compartilhar_documento.data ) { 

            let comp = res.data.gerar_texto_compartilhar_documento.data;

            // console.log('comp', comp);

            if ( comp && comp.block_lista ) { 
              this.texto_compartilhar_documento = null;  
            } else { 
              this.texto_compartilhar_documento = comp;
            }

          }

          this.$nextTick(() => { 

            if ( this.$refs.aei && ( this.$refs.aei.length || !Array.isArray(this.$refs.aei) ) ) { 
                let aeis = Array.isArray(this.$refs.aei) ? this.$refs.aei : [this.$refs.aei];
                aeis.forEach(item => { 
                    item.init();
                });
            }

          });

        }
      })
      .finally(() => { 
        this.$store.commit("loading", false);
        
        $('a[data-toggle="tab"]').on('shown.bs.tab', function () {
            window.dispatchEvent(new Event('resize'));
        });
       
      });
        
    },
    cancelarProntuario() { 
      if ( !confirm ('Confirma realizar o cancelamento desse atendimento? Isso irá cancelar o registro no prontuário.') )
        return;

      this.$util.remover(this, { 
        service: 'pep',
        dados: { 
          id_atendimento: this.atendimento.id_atendimento,
        },
        callback: () => { 
          this.ir_para_lista();
          // this.$router.push({ name: 'consultorio' });
        }
      });
    },

    reabrirProntuario() { 
      if ( !confirm ('Confirma reabrir o atendimento (cancelando a finalização realizada)?') )
        return;

      this.$util.atualizar(this, { 
        service: 'pep',
        func: 'reabrir',
        dados: { 
          id_atendimento: this.atendimento.id_atendimento,
          fila: this.fila, 
        },
        callback: () => { 
          this.load();
        }
      });
    },

    verificar_nao_salvo() { 

      if ( this.$refs.anamnese && ( this.$refs.anamnese.length || !Array.isArray(this.$refs.anamnese) ) ) { 
  
        let anamneses = Array.isArray(this.$refs.anamnese) ? this.$refs.anamnese : [this.$refs.anamnese];
        let nao_salvo = anamneses.find(item => !item.salvado()); 

        if ( nao_salvo ) { 
          this.$toast.add({
            severity: "error",
            summary: "Finalizar",
            detail: "Evolução não salva.",
            life: 5000
          });

          nao_salvo.salvar();

          return true;
        }
      }

      if ( this.$refs.laudoedit && ( this.$refs.laudoedit.length || !Array.isArray(this.$refs.laudoedit) ) ) { 

        let laudos = Array.isArray(this.$refs.laudoedit) ? this.$refs.laudoedit : [this.$refs.laudoedit];
        let laudos_nao_salvos = laudos.filter(item => !item.salvado());

        if ( laudos_nao_salvos.length ) {

            console.log('Laudos não salvos', laudos_nao_salvos);

            let titulos = laudos_nao_salvos.map(item => !item.atendimento_procedimento ? 'Laudo' : item.atendimento_procedimento.procedimento.search).join(', ');

            this.$toast.add({
                severity: "error",
                summary: "Finalizar",
                detail: "Laudo não salvo: " + titulos,
                life: 5000
            });

            return true;

        }

      }

      if ( this.$refs.aei && ( this.$refs.aei.length || !Array.isArray(this.$refs.aei) ) ) { 

        let aeis = Array.isArray(this.$refs.aei) ? this.$refs.aei : [this.$refs.aei];
        let lista = aeis.flatMap(item => item.verificar_items_nao_salvos());

        if ( lista.length ) {

          let titulos = lista.map(item => !item.modelo ? 'Registro' : item.modelo.search).join(', ');
          
          this.$toast.add({
            severity: "error",
            summary: "Finalizar",
            detail: "Evolução não salva: " + titulos,
            life: 5000
          });

          return true;

        }

      }

      return false;

    },

    selecionarFinalizar() {

      if ( this.verificar_nao_salvo() ) { 
        return;
      }

      /*
      if ( this.$refs.anamnese && this.$refs.anamnese.length ) { 
        let nao_salvo = this.$refs.anamnese.find(item => !item.salvado()); 

        if ( nao_salvo ) { 
          this.$toast.add({
            severity: "error",
            summary: "Finalizar",
            detail: "Evolução não salva.",
            life: 5000
          });

          nao_salvo.salvar();

          return;
        }
      }
      */

      this.validate = true;
      this.edicao_cid = null;

      this.$nextTick(() => {
        const invalids = $("#anamneseForm .invalid");

        if (invalids.length && $("#anamneseForm .invalid").is(":visible")) {
          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Verificar preenchimento dos campos.",
            life: 3000
          });
          return;
        }

        const invalid_laudos = $("#laudoForm .invalid");

        if (invalid_laudos.length && $("#laudoForm .invalid").is(":visible")) {
          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Verificar preenchimento dos campos.",
            life: 3000
          });
          return;
        }

        this.validate = false;

        this.edicao_cid = { 
          id_atendimento: this.atendimento.id_atendimento,
          id_cid: this.atendimento.id_cid, 
        };

        if ( this.$util.getCookie('cn-ncf') == 'S' ) { 
          this.finalizar();
        } else { 

            if ( this.atendimento.paciente.campos_customizados && this.atendimento.paciente.campos_customizados.js_campos ) { 

                let campos_paciente = this.$utilform.obter_obj_campos(this.atendimento.paciente.campos_customizados.js_campos, true);

                let campos_anamnese = this.atendimento.atendimento_procedimentos.flatMap(atp => { 
                    if ( atp.anamnese && atp.anamnese.dados && atp.anamnese.dados.length ) { 
                        return this.$utilform.obter_obj_campos(atp.anamnese.dados, true);
                    } 

                    return [];
                })
                .filter(campo => ( campo.id && campos_paciente.find(cp => cp.id == campo.id && cp.value !== campo.value)));

                if ( campos_anamnese.length ) { 
                    campos_anamnese = _.cloneDeep(campos_anamnese);
                    campos_anamnese = campos_anamnese.map(item => { 
                        item.selec = true;
                        return item;
                    });
                }

                this.dados_atualizar_paciente = campos_anamnese;
                    
            }

            $("#finalizarAtendimentoModal").modal("show");

        }
      });

    },

    finalizar() {
      if ( this.precisa_finalizar_laudo && this.info_fechar_laudo && this.info_registrar_entrega && !this.info_entregue_para ) { 

        this.$toast.add({
            severity: "error",
            summary: "Entrega",
            detail: "Informe o nome para quem o laudo está sendo entregue.",
            life: 5000
          });
          
          return;

      }

      this.$store.commit("loading", true);

      let enviar_docs = false;
      let fila_encerrar = true;

      if ( this.documentos_certificados && this.documentos_certificados.length ) { 
        this.$util.setCookie('enviar-docs', this.enviar_docs, 365);
        enviar_docs = this.enviar_docs;
      }

      if ( this.filaLaudo && this.filaLaudo.fl_pos_atendimento ) { // && this.consultorio_pausado ) { 
        fila_encerrar = ( this.$store.state.user.id_pessoa == this.atendimento.id_medico || this.filaLaudo.encerrar ) ? true : false;  
      }

      let query = {
        q: [
          {
            name: "atendimentos.finalizar",
            id: "iniciar",
            parms: {
              id: this.atendimento.id_atendimento,
              enviar_docs: enviar_docs, 
              email: this.atendimento.paciente.cadastro.st_email,
              local: this.$util.getCookie('local-chamada'),
              fechar_laudo: this.precisa_finalizar_laudo && this.info_fechar_laudo, 
              registrar_entrega: this.info_registrar_entrega,
              entregar_para: this.info_entregue_para, 
              consultorio: true, 
              fila: this.fila, 
              encerrar_final: fila_encerrar, 
              pos_atend: this.filaLaudo ? this.filaLaudo.fl_pos_atendimento : false, 
              id_cid: ( this.cid_obrig && this.edicao_cid ) ? this.edicao_cid.id_cid : null, 
              dados_atualizar_paciente: this.dados_atualizar_paciente ? this.dados_atualizar_paciente.filter(item => item.selec) : null,
            }
          }
        ]
      };

      this.axios
        .post("/aql", query)
        .then(res => {
          if (res.data.iniciar.status == 200) {

            if ( !res.data.iniciar.data || !res.data.iniciar.data.id_atendimento ) { 
              this.$toast.add({
                severity: "error",
                summary: "Finalizar",
                detail: "Falha ao finalizar o atendimento.",
                life: 5000
              });
              return;
            }

            if (res.data.iniciar.data.id_etapa_atendimento == 7 || res.data.iniciar.data.id_etapa_atendimento == 16) {
              this.$store.commit("loading", false);
              $("#finalizarAtendimentoModal").modal("hide");
              this.ir_para_lista();
            }
            
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },

    tour() { 
      window.scrollTo(0,0);

      // Define the tour!
      var tour = {
        id: "hello-hopscotch",
        i18n: { 
                doneBtn: "Pronto",
                nextBtn: "Próximo",
                prevBtn: "Anterior",
                skipBtn: "Pular"
            },
        steps: [
          {
            title: "Informações do Paciente",
            content: "Esse quadro exibe as informações do paciente. Para visualizar detalhes do cadastro, clique no link 'Dados Cadastrais'",
            target: "ficha-paciente",
            placement: "bottom"
          },
          {
            title: "Lista de Pacientes",
            content: "Clique aqui para retornar para sua lista de pacientes.",
            target: "lista-de-pacientes",
            placement: "bottom"
          },
          {
            title: "Ver Histórico do Prontuário",
            content: "Clique aqui para visualizar o histórico do prontuário desse paciente. Será aberta uma página de acesso rápido com o histórico, sem interromper o atendimento em curso.",
            target: "historico-prontuario",
            placement: "bottom"
          },
          {
            title: "Vídeo Chamada",
            content: "Caso o atendimento for ser realizado na modalidade de tele-atendimento, utilize esse botão para abrir a visualização da vídeo chamada. Você poderá então iniciar a vídeo chamada, e em seguida, compartilhar o link com o paciente.",
            target: "botao-video-chamada",
            placement: "left"
          },
          {
            title: "Reconhecimento de Voz",
            content: "Utilize esse botão para realizar a captura do texto via reconhecimento de voz. Após a conclusão da captura, copie o texto capturado e cole no campo desejado.",
            target: "botao-reconhecimento-voz",
            placement: "left"
          },
          {
            title: "Galeria de Imagens",
            content: "Caso você tenha imagens anexadas ao prontuário do paciente, utilize esse botão para visualizá-las e realizar comparações.",
            target: "botao-galeria-de-imagens",
            placement: "left",
          },
          {
            title: "Planilha de Resultados",
            content: "Utilize esse botão para registrar e consultar o histórico de resultados de exames laboratoriais, em formato de planilha.",
            target: "botao-resultados-exames",
            placement: "left",
          },
          {
            title: "Busca Livre de Paciente",
            content: "Caso se deseje consultar o histórico de um outro paciente, é possível utilizar esse campo para realizar a busca pelo nome ou CPF do paciente.",
            target: "autocomplete-paciente",
            placement: "bottom"
          },
        ]
      };

      window.hopscotch.startTour(tour);
    },
  },

  beforeMount() { 
    this.search_historico = this.$util.getCookie('pep-sh');

    if ( this.search_historico && this.search_historico.slice(0,1) == '[' && this.search_historico.slice(2,3) == ']' ) {
        this.filtro_avancado_historico = this.search_historico.slice(1,2);
        this.search_historico = this.search_historico.slice(3);
    }

    if ( this.search_historico ) { 
      this.busca_avancada = true;
      this.search_historico_manter = true;
    }
  },

  mounted() {
    this.enviar_docs = this.$util.getCookie('enviar-docs');

    if (this.id) {
      this.id_atendimento = this.id;
      this.load();
    }

    if ( this.$route.meta.vacina ) { 
      this.$store.commit("setBreadcrumb", [
        { name: "Vacina", path: "/vacina" },
        { name: "Carregando...", path: "/vacina/atend" }
      ]);
    } else if ( this.$route.meta.enfermagem && this.$route.meta.cc ) { 
      this.$store.commit("setBreadcrumb", [
        { name: "Centro Cirúrgico", path: '/centro-cirurgico/marcacao' }, 
        { name: "Atendimento", path: '/centro-cirurgico/atendimento' }, 
        { name: "Carregando...", path: "/assistencia/atend" }
      ]);
    } else if ( this.$route.meta.enfermagem || this.fila ) { 
      this.$store.commit("setBreadcrumb", [
        { name: "Assistência", method: this.ir_para_pacientes }, // path: "/assistencia/atend", 
        { name: "Carregando...", path: "/assistencia/atend" }
      ]);
    } else if ( this.$route.meta.internacao  ) { 
      this.$store.commit("setBreadcrumb", [
        { name: "Internação", path: "/internacao/internados" },
        { name: "Carregando..." }
      ]);
    } else { 
      this.$store.commit("setBreadcrumb", [
        { name: "Consultório", path: "/consultorio" },
        { name: "Carregando...", path: "/consultorio" }
      ]);
    }

    //

    let order_set_stats_cache = this.$store.state.options['order_set_stats']; 

    if ( !order_set_stats_cache ) { 

        this.$util.loadItem(this, {
            service: 'pep',
            func: 'order_set_stats',
        })
        .then(res => { 
            this.$store.commit('setOptions', { name: 'order_set_stats', list: res });
        });

    }
    
    
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.sticky-sidebar {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 160px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  left: 0;
  background-color: #111; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 116px;
}

.sticky-sidebar-right {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 160px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  right: 0;
  background-color: #111; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 116px;
}
</style>
